// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-08-27T21:37:05.437Z
// Property: Portico at Friars Creek Apts (ID: 6767906449165620)
// Collections: 30 amenities, 6 floorplans (live), 52 photos, 58 POIs, 5 reviews, 1 virtual tours, 7 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162419",
  "multihub_property_id": "6767906449165620",
  "property_external_id": "gql9lmy",
  "property_zillow_url": "https://www.zillow.com/homedetails/507-Marlandwood-Rd-Temple-TX-76502/243195747_zpid/",
  "property_apartments_url": "https://www.apartments.com/portico-at-friars-creek-apts-temple-tx/gql9lmy/",
  "property_google_business_url": "https://www.google.com/maps/place/Portico+at+Friars+Creek+Apartments/data=!4m2!3m1!1s0x0:0x6f633394831e36da?sa=X&ved=2ahUKEwjt2bjQ_bySAxXUJUQIHTlwKM4Q_BJ6BAg3EAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": null,
  "property_crm_software": null,
  "property_pm_software": null,
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "portico-at-friars-creek-apts",
  "property_name": "Portico at Friars Creek Apts",
  "property_website_url": "https://www.caseusa.com/apartments/tx/temple/portico-at-friars-creek-apts/",
  "property_domain": null,
  "property_address": "507 Marlandwood Road",
  "property_full_address": "507 Marlandwood Road, Temple, TX, 76502",
  "property_address_1": "507 Marlandwood Road",
  "property_address_2": null,
  "property_address_city": "Temple",
  "property_address_state": "TX",
  "property_address_zip_full": null,
  "property_address_zip": "76502",
  "property_address_country": "US",
  "property_address_county": "Bell County",
  "property_neighborhood_address": "Temple",
  "property_address_latitude": "31.0609",
  "property_address_longitude": "-97.3607",
  "property_email": "portico@caseusa.com",
  "property_phone": "(254) 876-6429",
  "property_call_tracking_phone": "844-741-0208",
  "property_company_name": "Case & Associates",
  "property_company_url": "https://www.caseusa.com/",
  "agency_contacts": null,
  "property_type": "Apartments",
  "property_short_description": "At Portico at Friars Creek in Temple, Texas, our thoughtfully designed one- and two-bedroom apartments blend comfort with modern amenities. Enjoy a refreshing dip in the pool, energize in the fitness center, or unwind in the cabana. Come see why your perfect home awaits—schedule a tour today! Prefer to explore on your own time? Self-guided tours are available.",
  "property_long_description": "**Discover Your Dream Home at Portico at Friars Creek Apartments in Temple, Texas!** \n\nWelcome to Portico at Friars Creek, where modern living meets exceptional amenities. Our stunning community offers a variety of thoughtfully designed floor plans, including spacious one and two-bedroom apartments that cater to your lifestyle needs. Each home features high ceilings, walk-in closets, and a fully-equipped kitchen with stainless steel appliances, ensuring comfort and elegance.\n\nStep outside your apartment and indulge in our resort-style amenities. Enjoy sunny days lounging by our sparkling pool or hosting friends at the BBQ grill in our beautifully landscaped courtyard. Stay active in our state-of-the-art fitness center, or unwind in the cozy clubhouse with engaging social activities. For your convenience, we offer 24-hour access, controlled entry, and an on-site maintenance team to meet all your needs.\n\nPortico at Friars Creek is ideally located near walking and biking trails, making it easy to enjoy the great outdoors. Our pet-friendly community features a dedicated pet play area, ensuring your furry friends have plenty of space to roam and explore. \n\nExperience the lifestyle you’ve always wanted in Temple, Texas, where charm and convenience come together at Portico at Friars Creek Apartments. With additional features such as high-speed internet access, spacious balconies or patios, and an attentive package service, we have everything you need to feel right at home.\n\nDon’t wait any longer—**find your new home today!** Browse our availability or schedule a tour to visit our vibrant community and see for yourself what makes Portico at Friars Creek the perfect place to live!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019cfb46-5d78-761b-a3eb-1242d40ab171.webp",
  "property_featured_image_media": {
    "alt_text": "Aerial view of apartment complex with swimming pool and surrounding buildings.",
    "public_id": "019cfb46-5d78-761b-a3eb-1242d40ab171",
    "storage_key": "property/6767906449165620/019cfb46-5d78-761b-a3eb-1242d40ab171.webp",
    "width": 2048,
    "height": 1365
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "264",
  "property_year_built": "2018",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "93.56060606060606",
  "property_admin_fee": null,
  "property_application_fee": "75",
  "property_fees_deposit_info": null,
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "500",
  "property_pet_deposit": "0",
  "property_monthly_pet_rent": "30",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "0",
  "property_pet_restrictions": "2 Pet Max, 80lb max",
  "property_pet_policy_description": "2 Pet Max, 80lb max",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://porticoapartmentstemple.securecafe.com/onlineleasing/portico-at-friar-s-creek-apts/floorplans.aspx",
  "property_resident_portal_url": "https://porticoapartmentstemple.securecafe.com/residentservices/portico-at-friar-s-creek-apts/userlogin.aspx",
  "property_apply_now_url": "https://porticoapartmentstemple.securecafe.com/onlineleasing/portico-at-friar-s-creek-apts/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019cfb45-9c40-76cf-8048-6602f45c6b43.webp",
  "property_primary_logo_media": {
    "alt_text": "The Portico at Friars Creek logo",
    "public_id": "019cfb45-9c40-76cf-8048-6602f45c6b43",
    "storage_key": "property/6767906449165620/019cfb45-9c40-76cf-8048-6602f45c6b43.webp",
    "width": 300,
    "height": 80
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019cfb46-b1a8-75b9-936d-535bccc89f65.webp",
  "property_secondary_logo_media": {
    "alt_text": "CASE & ASSOCIATES logo",
    "public_id": "019cfb46-b1a8-75b9-936d-535bccc89f65",
    "storage_key": "property/6767906449165620/019cfb46-b1a8-75b9-936d-535bccc89f65.webp",
    "width": 325,
    "height": 325
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019cfb46-bfe2-7706-8e58-685fbd2feecf.webp",
  "property_mono_white_logo_media": {
    "alt_text": "The Portico at Friars Creek logo",
    "public_id": "019cfb46-bfe2-7706-8e58-685fbd2feecf",
    "storage_key": "property/6767906449165620/019cfb46-bfe2-7706-8e58-685fbd2feecf.webp",
    "width": 300,
    "height": 80
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019cfb46-ce88-711d-8e4e-727dc40f7c72.webp",
  "property_mono_black_logo_media": {
    "alt_text": "The Portico at Friars Creek logo",
    "public_id": "019cfb46-ce88-711d-8e4e-727dc40f7c72",
    "storage_key": "property/6767906449165620/019cfb46-ce88-711d-8e4e-727dc40f7c72.webp",
    "width": 300,
    "height": 80
  },
  "property_company_icon": null,
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162419/019cfb35-ce4c-7138-92b0-dd454c056e38.webp",
  "property_company_logo_media": {
    "alt_text": "Case & Associates logo",
    "public_id": "019cfb35-ce4c-7138-92b0-dd454c056e38",
    "storage_key": "company/5767906449162419/019cfb35-ce4c-7138-92b0-dd454c056e38.webp",
    "width": 640,
    "height": 256
  },
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#075699",
  "property_secondary_color": "#6d6e70",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": "#000000",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 2",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "789 - 1108",
  "property_sqft_min": "789",
  "property_sqft_max": "1108",
  "property_price_range": "1169 - 1499",
  "property_price_min": "1169",
  "property_price_max": "1499",
  "property_available_units": 17,
  "property_facebook_url": "https://www.facebook.com/photo.php?fbid=1868766229961014&id=973430526161260&set=a.991401827697463",
  "property_instagram_url": "https://www.instagram.com/porticoatfriarscreek/?hl=en",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJ3cM7109rRYYR2jYeg5QzY28",
  "property_youtube_url": null,
  "property_yelp_url": "https://www.yelp.com/biz/portico-at-friars-creek-temple",
  "property_tiktok_url": "https://www.tiktok.com/@porticoatfriarscreek",
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Portico at Friars Creek Apts",
  "property_home_romance_title": "Embrace Life and Love in Your Perfect Apartment Community",
  "property_home_amenities_blurb": "At Portico at Friars Creek Apts in Temple, Texas, luxury meets comfort. Enjoy spacious one- and two-bedroom layouts equipped with modern amenities, from stainless steel appliances to walk-in closets. Relax poolside, break a sweat in our fitness center, or mingle in the clubhouse—your perfect lifestyle awaits!",
  "property_home_floorplans_blurb": "Welcome to Portico at Friars Creek Apts in vibrant Temple, Texas, where stylish one and two-bedroom floor plans meet modern living. With spacious designs and thoughtful amenities, your ideal home awaits. Browse our available apartment homes today and step into a community crafted for comfort and convenience.",
  "property_home_gallery_blurb": "Welcome to Portico at Friars Creek, where vibrant living meets comfort in Temple, Texas. Choose from spacious one- or two-bedroom floor plans, complete with modern amenities like a sparkling pool, fitness center, and pet-friendly spaces. Picture yourself enjoying the sundeck, grilling with friends, and exploring scenic walking trails—all just steps from home!",
  "property_home_neighborhood_blurb": "Experience modern living at Portico at Friars Creek Apts in Temple, Texas. Nestled near vibrant parks, family-friendly attractions like the Temple Children's Museum, and fitness hubs such as Crunch Fitness and Planet Fitness, our community offers one and two-bedroom floor plans perfect for every lifestyle. Your new adventure begins here!",
  "property_home_reviews_blurb": "At Portico at Friars Creek, residents cherish the welcoming, tight-knit community where “everyone is very nice and respectful.” With serene surroundings and attentive staff, it's no wonder that tenants rave about their experience. Comfortable living meets exceptional service in the heart of Temple, Texas. Join us and feel at home today!",
  "property_neighborhood_blurb": "At Portico at Friars Creek in Temple, Texas, life extends beyond your stylish one or two-bedroom apartment. Revel in community adventures at Temple Children's Museum, Xtreme Jump Adventure Park, and Heritage Park. With exceptional amenities like Baylor Scott & White Medical Center and vibrant local attractions, your perfect neighborhood awaits.",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At Portico at Friars Creek Apts in Temple, Texas, enjoy a lifestyle infused with luxury and convenience. Dive into our sparkling pool, energize at the fitness center, or unwind in our vibrant clubhouse. With spacious floor plans and delightful outdoor spaces, your perfect home awaits. Join us today for your ideal living experience!",
  "property_applynow_blurb": "At Portico at Friars Creek in Temple, Texas, your ideal lifestyle awaits with spacious one and two-bedroom apartments. Enjoy resort-style amenities like a sparkling pool, state-of-the-art fitness center, and vibrant social activities. With convenient online services and a pet-friendly environment, finding your perfect home is just a click away!",
  "property_contactus_blurb": "At Portico at Friars Creek Apts in Temple, Texas, choose from thoughtfully designed one and two-bedroom floor plans that blend comfort and style. Crafted for modern living, our spaces invite you to create your perfect home. Have questions? Contact our leasing team today!",
  "property_faqs_blurb": "At Portico at Friars Creek Apts in Temple, Texas, our diverse floor plans cater to every lifestyle, from cozy one-bedrooms to spacious two-bedrooms. Unravel the details of community living by browsing our FAQs page, where you’ll find answers to all your burning questions about your future home.",
  "property_floorplans_blurb": "At Portico at Friars Creek Apts in Temple, Texas, our thoughtfully designed floor plans include spacious one and two-bedroom options tailored to your lifestyle. Each layout offers modern comforts and stylish finishes. Browse our available apartment homes and let your journey to the perfect living space begin today!",
  "property_gallery_blurb": "At Portico at Friars Creek in Temple, Texas, vibrant living awaits! Imagine sunny days by the pool, energized workouts in our fitness center, and cozy evenings in the clubhouse. With a variety of spacious floor plans and top-notch amenities, picture yourself enjoying a community that truly feels like home!",
  "property_interactivemap_blurb": "Welcome to Portico at Friars Creek Apts in Temple, Texas! Choose from spacious one- and two-bedroom floor plans, enhanced by exceptional amenities like a relaxing pool, invigorating fitness center, and engaging social activities. Use our interactive community map to uncover your ideal home and start living your best life!",
  "property_pets_blurb": "Welcome to Portico at Friars Creek Apts in Temple, TX, where modern comfort meets tranquil living. Unwind in our thoughtfully designed homes, complete with pet-friendly spaces for your furry companions (up to 80 lbs). Experience a vibrant community that perfectly balances relaxation and convenience, right at your doorstep.",
  "property_referafriend_blurb": "At Portico at Friars Creek Apts in Temple, Texas, our variety of one and two-bedroom floor plans are designed to suit your lifestyle. Great friends make great neighbors—invite your friends to share in the comfort and charm of our vibrant community today! ",
  "property_residentaccess_blurb": "Welcome to Portico at Friars Creek Apts in Temple, Texas! Our thoughtfully designed one- and two-bedroom floor plans offer the ideal sanctuary for comfort and style. Log in to your resident portal to effortlessly manage rent payments, schedule maintenance, and embrace a seamless living experience today!",
  "property_reviews_blurb": "At Portico at Friars Creek in Temple, TX, residents are raving about their experiences in this friendly and welcoming community. With professional staff dedicated to maintaining a beautiful environment, one resident shared, \"The staff is amazing and very attentive,\" making it a place you'll love to call home. See what our residents have to say about living at our community!",
  "property_created_at": "1753982389569",
  "property_scheduletour_blurb": "At Portico at Friars Creek Apts in Temple, Texas, our thoughtfully designed one- and two-bedroom floor plans cater to your lifestyle. Experience the perfect blend of comfort and convenience. Curious about community life? Check out our residents’ testimonials and schedule a tour today! Your new home awaits!",
  "property_thankyou_blurb": "Thank you for reaching out to Portico at Friars Creek Apts in Temple, Texas! With spacious one and two-bedroom floor plans, our community blends comfort and style. A dedicated team member will be in touch soon to help you take the next step toward your new home. Stay tuned!",
  "property_virtualtours_blurb": "Welcome to Portico at Friars Creek Apts in Temple, Texas, where modern living meets comfort. Choose from spacious one or two-bedroom floor plans designed for your lifestyle. Experience our vibrant community through an immersive virtual tour—step inside and envision your new home today!",
  "property_copyright": "2025 All Rights Reserved. Portico at Friars Creek Apts",
  "property_seo_title_home": "Portico at Friars Creek Apts |  Apartments in Temple, Texas",
  "property_seo_description_home": "Discover luxury living at Portico at Friars Creek, Temple, TX. Enjoy spacious floor plans, top amenities, and a vibrant community. Welcome home!",
  "property_seo_title_floorplans": "Floor Plans | Temple, Texas Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal home at Portico at Friars Creek Apts in Temple, TX. Choose from spacious one and two-bedroom floor plans designed for your lifestyle.",
  "property_seo_title_amenities": "Amenities | Temple, Texas Apartments for Rent",
  "property_seo_description_amenities": "Elevate your lifestyle at Portico at Friars Creek Apts in Temple, TX! Enjoy resort-style amenities like a pool, fitness center, and pet-friendly spaces.",
  "property_seo_title_gallery": "Gallery | Apartments in Temple, Texas",
  "property_seo_description_gallery": "Experience life at Portico at Friars Creek Apts in Temple, TX. Stunning floor plans, amazing amenities, and vibrant surroundings await. Picture your new home!",
  "property_seo_title_virtualtours": "Virtual Tours | Portico at Friars Creek Apts Apartments",
  "property_seo_description_virtualtours": "Step into your future home at Portico at Friars Creek Apts in Temple, TX! Experience our one and two-bedroom apartments through a captivating virtual tour.",
  "property_seo_title_interactivemap": "Interactive Map | Portico at Friars Creek Apts Apartments",
  "property_seo_description_interactivemap": "Find your dream home at Portico at Friars Creek in Temple, TX! Use our interactive map to explore layouts, amenities, and discover your perfect apartment.",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Temple, Texas",
  "property_seo_description_neighborhood": "Uncover local treasures near Portico at Friars Creek Apts in Temple, Texas. Dive into vibrant neighborhoods, parks, and dining—your next adventure awaits!",
  "property_seo_title_contact": "Contact Us | Portico at Friars Creek Apts",
  "property_seo_description_contact": "Find your perfect home in Temple, TX at Portico at Friars Creek Apts. With one and two-bedroom floor plans, our leasing team is here to assist you today!",
  "property_seo_title_faqs": "FAQs | Apartments in Temple, Texas",
  "property_seo_description_faqs": "Find answers to your questions about Portico at Friars Creek Apts in Temple, Texas. Discover amenities, layouts, and community life tailored for you!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Temple, Texas",
  "property_seo_description_reviews": "Experience life at Portico at Friars Creek in Temple, TX. Our residents love the amenities, spacious layouts, and vibrant community. Check out their reviews!",
  "property_seo_title_applynow": "Apply Now | Apartments in Temple, Texas",
  "property_seo_description_applynow": "Elevate your lifestyle at Portico at Friars Creek, Temple, TX! Enjoy spacious layouts, resort-style amenities, and an active community. Lease online!",
  "property_seo_title_residentaccess": "Resident Access | Portico at Friars Creek Apts",
  "property_seo_description_residentaccess": "Access Portico at Friars Creek's resident portal for easy rent payments, maintenance requests, and community updates. Your convenience awaits in Temple, TX!",
  "property_seo_title_referafriend": "Refer A Friend | Portico at Friars Creek Apts",
  "property_seo_description_referafriend": "Refer a friend to Portico at Friars Creek Apts in Temple, TX! Great friends make great neighbors. Help them find their new home today!",
  "property_seo_title_scheduletour": "Schedule a Tour | Portico at Friars Creek Apts",
  "property_seo_description_scheduletour": "Experience the charm of Portico at Friars Creek Apts in Temple, TX! Schedule a tour today to see your future home filled with comfort and style.",
  "property_seo_title_privacy": "Privacy Policy | Portico at Friars Creek Apts",
  "property_seo_description_privacy": "Your privacy matters at Portico at Friars Creek Apts. Learn how we protect your information while you enjoy life in Temple, Texas. View our policy!",
  "property_seo_title_accessibility": "Website Accessibility | Portico at Friars Creek Apts",
  "property_seo_description_accessibility": "At Portico at Friars Creek Apts in Temple, we prioritize digital inclusion and accessibility for all. Experience a community designed for everyone.",
  "property_seo_title_sitemap": "Sitemap | Portico at Friars Creek Apts",
  "property_seo_description_sitemap": "Navigate your way to your new home at Portico at Friars Creek Apts in Temple, Texas. Check out our sitemap to see all we have to offer!",
  "property_seo_title_thankyou": "Thank You | Portico at Friars Creek Apts",
  "property_seo_description_thankyou": "Thank you for reaching out to Portico at Friars Creek Apts in Temple, TX! Our team will connect soon to help you find your perfect home. Stay tuned!",
  "property_seo_title_pets": "Pet Policy | Apartments in Temple, TX",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1787865610854",
  "amenities": [
    {
      "id": "custom_f8ea1263-621f-4b66-a2cf-a067622158c2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165620",
      "source": "custom",
      "external_id": "false",
      "title": "Grill & Chill Area",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_468bde4a-0042-4c06-a192-04572f784e2e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165620",
      "source": "custom",
      "external_id": "false",
      "title": "Business Center",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_59f8842a-bf7c-4d84-8d02-4240b44ba26e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165620",
      "source": "custom",
      "external_id": "false",
      "title": "Gated Electronic Entrance",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ab3cb990-4244-4030-8144-5d087c26c996",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165620",
      "source": "custom",
      "external_id": "false",
      "title": "Lush Courtyards with Pet Stations",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_1db26ba7-65e0-4316-911f-96318b0031a3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165620",
      "source": "custom",
      "external_id": "false",
      "title": "24‑Hour Fitness Center",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_e345ba8e-fc48-4cbb-a9e6-ebe05b47ffc4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165620",
      "source": "custom",
      "external_id": "false",
      "title": "flex. Payment Options Available",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_46fb1edf-f0e9-4ea3-a728-b05d8f2c4deb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165620",
      "source": "custom",
      "external_id": "false",
      "title": "24‑Hour Emergency Maintenance",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_8858a837-2ca7-4e22-860e-f77569c6bf71",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165620",
      "source": "custom",
      "external_id": "false",
      "title": "Internet Cafe with Complimentary Gourmet Coffee & Tea",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_da15d2a0-7981-4055-a420-457b10a651ab",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165620",
      "source": "custom",
      "external_id": "false",
      "title": "Onsite Management with Package Receiving",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_1f1efab8-413c-4627-9532-f26ca8ec1d77",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165620",
      "source": "custom",
      "external_id": "false",
      "title": "Resort Style Pool with Outdoor Cabana",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_50a5bb14-7571-4902-806c-c7c3cb1fbeca",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165620",
      "source": "custom",
      "external_id": "false",
      "title": "Onsite Bark Park",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_59c5a926-d797-4881-8867-91ea7265a154",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165620",
      "source": "custom",
      "external_id": "false",
      "title": "Relaxing Clubhouse",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_0cafa52f-f918-45a6-80e5-9cd62bcb0c8c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165620",
      "source": "custom",
      "external_id": "false",
      "title": "Close to I‑35",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b40f1e94-9df8-4b06-ae2c-34fb1dbf25b2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165620",
      "source": "custom",
      "external_id": "false",
      "title": "Central Heat & Air Conditioning",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_99fd4b48-b866-46a2-9da6-9e20b888191a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165620",
      "source": "custom",
      "external_id": "false",
      "title": "Cable Ready",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_f3cdce50-b105-43ef-a495-013cc84aad48",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165620",
      "source": "custom",
      "external_id": "false",
      "title": "Carpeting",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_aab10a58-e856-4c83-b493-b1a6ba46f57b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165620",
      "source": "custom",
      "external_id": "false",
      "title": "Ceiling Fans in Bedrooms",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_805a287e-9b26-4574-8c8f-cd4b4bbfb59e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165620",
      "source": "custom",
      "external_id": "false",
      "title": "Garbage Disposal",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_82196294-4fc8-4e08-a74d-8770d1051c9f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165620",
      "source": "custom",
      "external_id": "false",
      "title": "Stainless‑Steel Energy Efficient Appliances",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_866fe2db-17fb-47a8-9170-a07a8652f5b7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165620",
      "source": "custom",
      "external_id": "false",
      "title": "9‑Foot Ceilings*",
      "amount": "false",
      "description": "*In select homes",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_5a5e6a87-cbc5-4614-a2e3-2e3af1751ab5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165620",
      "source": "custom",
      "external_id": "false",
      "title": "Walk‑In Closets",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_cde2ede4-e073-4740-9ee0-a16a9ef1c6ef",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165620",
      "source": "custom",
      "external_id": "false",
      "title": "Private Balcony or Patio*",
      "amount": "false",
      "description": "*In select homes",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_9cd9c13c-c35b-433b-9f4b-861c2a6d397d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165620",
      "source": "custom",
      "external_id": "false",
      "title": "Washer & Dryer Connections",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ecc870e8-83d5-4259-bbde-7fb01d4bbc99",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165620",
      "source": "custom",
      "external_id": "false",
      "title": "Handicap Accessible*",
      "amount": "false",
      "description": "*In select homes",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_53b19973-7554-4907-a970-ceec55dad965",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165620",
      "source": "custom",
      "external_id": "false",
      "title": "Window Coverings",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_4ce335b4-7a51-4bfe-8dd8-86e04d6d5533",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165620",
      "source": "custom",
      "external_id": "false",
      "title": "Designer Colors",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_494be007-897a-4293-a246-95561a9fcc33",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165620",
      "source": "custom",
      "external_id": "false",
      "title": "Vaulted Ceilings*",
      "amount": "false",
      "description": "*In select homes",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_fc025217-1b50-4ecd-9e5a-dda492ccc232",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165620",
      "source": "custom",
      "external_id": "false",
      "title": "Extra Storage",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_7121f53b-6036-477b-b523-2d7d3fb14937",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165620",
      "source": "custom",
      "external_id": "false",
      "title": "High Speed Internet Access Ready",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_c3444ce8-cb23-44df-a7c2-fabac627f825",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165620",
      "source": "custom",
      "external_id": "false",
      "title": "Garages Available*",
      "amount": "false",
      "description": "*",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_88269ab5-8900-472e-a84c-648e9d25ea97",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165620",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019d20af-b544-722a-8188-cd0d56f6b1c9.webp",
      "image_media": {
        "alt_text": "The Portico at Friars Creek Apartments monument sign and building exterior.",
        "public_id": "019d20af-b544-722a-8188-cd0d56f6b1c9",
        "storage_key": "property/6767906449165620/019d20af-b544-722a-8188-cd0d56f6b1c9.webp",
        "width": 1280,
        "height": 1024
      },
      "title": "Community",
      "description": "Welcome to The Portico at Friars Creek Apartments, featuring a beautiful monument sign and attractive building architecture.",
      "link": "",
      "alt_text": "The Portico at Friars Creek Apartments monument sign and building exterior.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019cfb45-222e-70f9-a42b-5b9e1f536878.webp"
    },
    {
      "id": "custom_a4980f26-8238-4553-9e9f-241b4bf20240",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165620",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019d20af-b54a-710a-8917-5ee4ae01debf.webp",
      "image_media": {
        "alt_text": "The Portico at Friars Creek Apartments monument sign.",
        "public_id": "019d20af-b54a-710a-8917-5ee4ae01debf",
        "storage_key": "property/6767906449165620/019d20af-b54a-710a-8917-5ee4ae01debf.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Welcome to The Portico at Friars Creek Apartments, a beautiful community offering modern living spaces and convenient amenities.",
      "link": "",
      "alt_text": "The Portico at Friars Creek Apartments monument sign.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019cfb45-2684-74b7-8f5d-4d6622d88492.webp"
    },
    {
      "id": "custom_7dc85954-3ac0-4817-b509-909f3536e3a6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165620",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019d20af-b542-7329-b8fa-ec111834427f.webp",
      "image_media": {
        "alt_text": "Portico apartment complex exterior with arched entryway and signage.",
        "public_id": "019d20af-b542-7329-b8fa-ec111834427f",
        "storage_key": "property/6767906449165620/019d20af-b542-7329-b8fa-ec111834427f.webp",
        "width": 1280,
        "height": 852
      },
      "title": "Community",
      "description": "Exterior view of the Portico apartment complex, showcasing its charming architecture and welcoming entrance.",
      "link": "",
      "alt_text": "Portico apartment complex exterior with arched entryway and signage.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019cfb45-3699-735a-a530-4619028168c9.webp"
    },
    {
      "id": "custom_214633fb-89f1-4e13-abb8-8b9e4412cba5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165620",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019d20af-b561-7268-bd62-098368769e88.webp",
      "image_media": {
        "alt_text": "Welcome to Canine Creek dog park and apartment buildings.",
        "public_id": "019d20af-b561-7268-bd62-098368769e88",
        "storage_key": "property/6767906449165620/019d20af-b561-7268-bd62-098368769e88.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "A welcoming outdoor dog park with picnic tables and apartment buildings in the background.",
      "link": "",
      "alt_text": "Welcome to Canine Creek dog park and apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019cfb45-31d5-73e5-afbc-917fa0b2afdd.webp"
    },
    {
      "id": "custom_1853f782-382a-47cb-94e1-168f1a039b16",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165620",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019d20af-be8a-71fc-956c-6745afe3603f.webp",
      "image_media": {
        "alt_text": "Apartment complex courtyard with a fenced-in dog park featuring agility equipment like tunnels and hoops.",
        "public_id": "019d20af-be8a-71fc-956c-6745afe3603f",
        "storage_key": "property/6767906449165620/019d20af-be8a-71fc-956c-6745afe3603f.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Enjoy our spacious courtyard and dedicated dog park, complete with fun agility equipment for your furry friends to play and explore.",
      "link": "",
      "alt_text": "Apartment complex courtyard with a fenced-in dog park featuring agility equipment like tunnels and hoops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449165620/019cfb45-a478-711b-8d22-caa8525232e1.webp"
    },
    {
      "id": "custom_4d0d51dd-d440-4d06-817c-ceab72c5e136",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165620",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019d20af-c417-764c-8496-9f87d36a82a4.webp",
      "image_media": {
        "alt_text": "View of the community grounds from a balcony, showing buildings, a pool, and landscaping under a blue sky.",
        "public_id": "019d20af-c417-764c-8496-9f87d36a82a4",
        "storage_key": "property/6767906449165620/019d20af-c417-764c-8496-9f87d36a82a4.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Enjoy the beautiful community grounds from your private balcony, featuring lush greenery, a sparkling pool, and resort-style amenities.",
      "link": "",
      "alt_text": "View of the community grounds from a balcony, showing buildings, a pool, and landscaping under a blue sky.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449165620/019cfb45-a3dd-7179-981d-243475bd7238.webp"
    },
    {
      "id": "custom_582aa590-07d5-443b-842b-605876cab7d6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165620",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019d20af-c88d-721b-bc81-272079a93583.webp",
      "image_media": {
        "alt_text": "Covered patio area with stone accent walls, outdoor seating, and large planters.",
        "public_id": "019d20af-c88d-721b-bc81-272079a93583",
        "storage_key": "property/6767906449165620/019d20af-c88d-721b-bc81-272079a93583.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Relax and unwind on our inviting outdoor patio, featuring comfortable seating and elegant stone accents. Perfect for enjoying fresh air.",
      "link": "",
      "alt_text": "Covered patio area with stone accent walls, outdoor seating, and large planters.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449165620/019cfb45-9ca5-71fe-8d7b-9d3fe324d98e.webp"
    },
    {
      "id": "custom_3503ae8d-1a4d-4c42-8af3-7e8b6543c312",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165620",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019d20af-cd07-7687-bfd7-979b1899fe66.webp",
      "image_media": {
        "alt_text": "Outdoor grilling area with built-in grills, fireplace, and picnic tables under a wooden pergola.",
        "public_id": "019d20af-cd07-7687-bfd7-979b1899fe66",
        "storage_key": "property/6767906449165620/019d20af-cd07-7687-bfd7-979b1899fe66.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Enjoy outdoor cooking and gatherings in this amenity-rich community space featuring built-in grills, a cozy fireplace, and ample seating under a charming pergola.",
      "link": "",
      "alt_text": "Outdoor grilling area with built-in grills, fireplace, and picnic tables under a wooden pergola.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019cfb45-510c-749a-ad3a-7ae09b12f5ed.webp"
    },
    {
      "id": "custom_6fd49d5a-6184-4fd0-91e3-3af1345f3631",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165620",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019d20af-cda3-701a-9aaa-ab5d6fd706b5.webp",
      "image_media": {
        "alt_text": "Courtyard with a modern blue sculpture and landscaped planters in front of a building with a terracotta roof.",
        "public_id": "019d20af-cda3-701a-9aaa-ab5d6fd706b5",
        "storage_key": "property/6767906449165620/019d20af-cda3-701a-9aaa-ab5d6fd706b5.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Experience the inviting atmosphere of our community courtyard, featuring a striking blue sculpture and beautifully landscaped planters, perfect for relaxation and enjoyment.",
      "link": "",
      "alt_text": "Courtyard with a modern blue sculpture and landscaped planters in front of a building with a terracotta roof.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019cfb45-2ad2-7428-a655-2be7bc67c5b2.webp"
    },
    {
      "id": "custom_36d9802f-b095-452b-b21f-340333cf53d8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165620",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019d20af-d094-75ee-bd37-426f64ff5568.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas.",
        "public_id": "019d20af-d094-75ee-bd37-426f64ff5568",
        "storage_key": "property/6767906449165620/019d20af-d094-75ee-bd37-426f64ff5568.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Relax and unwind by our sparkling swimming pool, complete with comfortable lounge chairs and shaded areas.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019cfb45-3551-703f-b04b-f1a66e46532a.webp"
    },
    {
      "id": "custom_232949d7-9f02-4ef8-8fbd-b8db3393a553",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165620",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019d20af-d49a-74ad-ab39-cd4f555e0ff5.webp",
      "image_media": {
        "alt_text": "Outdoor covered seating area with blue striped furniture and a large television on a brick wall.",
        "public_id": "019d20af-d49a-74ad-ab39-cd4f555e0ff5",
        "storage_key": "property/6767906449165620/019d20af-d49a-74ad-ab39-cd4f555e0ff5.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Relax and unwind in our comfortable outdoor lounge area, complete with plush seating and a large screen TV. Perfect for gathering with friends or enjoying a quiet moment.",
      "link": "",
      "alt_text": "Outdoor covered seating area with blue striped furniture and a large television on a brick wall.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019cfb45-39f6-7188-a055-5151bf040515.webp"
    },
    {
      "id": "custom_53bd82fb-b34b-440b-b34f-35f236a2820d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165620",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019d20af-d841-754b-b0e2-17b304d9a05c.webp",
      "image_media": {
        "alt_text": "Spacious leasing office lobby with seating areas, fireplace, and reception desk.",
        "public_id": "019d20af-d841-754b-b0e2-17b304d9a05c",
        "storage_key": "property/6767906449165620/019d20af-d841-754b-b0e2-17b304d9a05c.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Welcome to our modern leasing office lobby, featuring comfortable seating, a cozy fireplace, and a fully equipped reception area.",
      "link": "",
      "alt_text": "Spacious leasing office lobby with seating areas, fireplace, and reception desk.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019cfb45-3bdb-71c8-8208-81e2dcb84ca0.webp"
    },
    {
      "id": "custom_c0323b90-58a7-4e6c-8bf8-73cb74b84f82",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165620",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019d20af-d909-713b-a67e-5706126ab2cc.webp",
      "image_media": {
        "alt_text": "Well-equipped fitness center with treadmills, weight machines, and free weights.",
        "public_id": "019d20af-d909-713b-a67e-5706126ab2cc",
        "storage_key": "property/6767906449165620/019d20af-d909-713b-a67e-5706126ab2cc.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, featuring a wide range of cardio and strength training equipment for a complete workout.",
      "link": "",
      "alt_text": "Well-equipped fitness center with treadmills, weight machines, and free weights.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019cfb45-4a11-77b2-9a6f-35d9958a037d.webp"
    },
    {
      "id": "custom_826f26cd-3b54-4c71-b058-29638efed8f7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165620",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019d20af-de0d-729a-be2f-ac934405f77a.webp",
      "image_media": {
        "alt_text": "Clubhouse living area with fireplace, seating, and reception desk.",
        "public_id": "019d20af-de0d-729a-be2f-ac934405f77a",
        "storage_key": "property/6767906449165620/019d20af-de0d-729a-be2f-ac934405f77a.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Enjoy the spacious and inviting clubhouse, perfect for relaxing or socializing. Features a modern fireplace, comfortable seating areas, and a welcoming reception desk.",
      "link": "",
      "alt_text": "Clubhouse living area with fireplace, seating, and reception desk.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019cfb45-6801-7407-9932-0d88c5cedeaf.webp"
    },
    {
      "id": "custom_7d9211f6-4245-4c93-b311-a9f199dd1139",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165620",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019d20af-e1d1-74d0-a114-2a33b025de47.webp",
      "image_media": {
        "alt_text": "Community kitchen area with island and seating",
        "public_id": "019d20af-e1d1-74d0-a114-2a33b025de47",
        "storage_key": "property/6767906449165620/019d20af-e1d1-74d0-a114-2a33b025de47.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Modern community kitchen with island seating and ample cabinet space, perfect for resident gatherings and events.",
      "link": "",
      "alt_text": "Community kitchen area with island and seating",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019cfb45-7f91-74d9-a170-c7e30d3fa929.webp"
    },
    {
      "id": "custom_a93e64ff-af21-43ac-9b04-12407188e1bd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165620",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019d20af-e1cb-773d-896e-014aa3e0723b.webp",
      "image_media": {
        "alt_text": "Bathroom with a toilet, vanity, and washer/dryer unit.",
        "public_id": "019d20af-e1cb-773d-896e-014aa3e0723b",
        "storage_key": "property/6767906449165620/019d20af-e1cb-773d-896e-014aa3e0723b.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Spacious bathroom featuring a vanity with a sink, a toilet, and a convenient in-unit washer and dryer.",
      "link": "",
      "alt_text": "Bathroom with a toilet, vanity, and washer/dryer unit.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019cfb45-7935-73fe-90d8-57f7418171d8.webp"
    },
    {
      "id": "custom_1f665615-6aa0-4224-98c7-5fcdc441b2e5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165620",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019d20af-e64a-753b-beed-61e704505194.webp",
      "image_media": {
        "alt_text": "Dining area and desk space with cactus mirrors.",
        "public_id": "019d20af-e64a-753b-beed-61e704505194",
        "storage_key": "property/6767906449165620/019d20af-e64a-753b-beed-61e704505194.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "This apartment features a dedicated dining area with a table and chairs, and a separate desk space with decorative mirrors on the wall.",
      "link": "",
      "alt_text": "Dining area and desk space with cactus mirrors.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019cfb45-23cd-7249-a5ac-86a92d777eb7.webp"
    },
    {
      "id": "custom_a9fe4a84-1776-494b-aee8-12deca397a2a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165620",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019d20af-ec44-725c-8349-dab4a895a74c.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-sized bed, two nightstands, a dresser, and a ceiling fan.",
        "public_id": "019d20af-ec44-725c-8349-dab4a895a74c",
        "storage_key": "property/6767906449165620/019d20af-ec44-725c-8349-dab4a895a74c.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Comfortable bedroom featuring a plush queen bed, ample storage with a dresser and nightstands, and a ceiling fan for year-round comfort.",
      "link": "",
      "alt_text": "Bedroom with a queen-sized bed, two nightstands, a dresser, and a ceiling fan.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019cfb45-22b2-717a-b128-4e6635d4c40a.webp"
    },
    {
      "id": "custom_427bf163-8ea7-4a72-b005-1c4061b570ea",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165620",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019d20af-ee9a-744f-8216-c2832b09aae6.webp",
      "image_media": {
        "alt_text": "Living room and dining area of a staged apartment with large windows and neutral decor.",
        "public_id": "019d20af-ee9a-744f-8216-c2832b09aae6",
        "storage_key": "property/6767906449165620/019d20af-ee9a-744f-8216-c2832b09aae6.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Spacious living and dining area featuring large windows for natural light, comfortable seating, and elegant decor, perfect for relaxing and entertaining.",
      "link": "",
      "alt_text": "Living room and dining area of a staged apartment with large windows and neutral decor.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019cfb45-2298-750d-b210-52969f63b74a.webp"
    },
    {
      "id": "custom_4b94151d-2f55-4fb8-be2e-0594525db780",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165620",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019d20af-f217-73af-8bda-b03ef331b836.webp",
      "image_media": {
        "alt_text": "A stylish desk area with a chair, abstract art, and decorative items.",
        "public_id": "019d20af-f217-73af-8bda-b03ef331b836",
        "storage_key": "property/6767906449165620/019d20af-f217-73af-8bda-b03ef331b836.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Create a productive and inspiring workspace in your apartment with this elegant desk setup, featuring modern art and sophisticated decor.",
      "link": "",
      "alt_text": "A stylish desk area with a chair, abstract art, and decorative items.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019cfb45-2291-705a-8533-5d51eac2b41c.webp"
    },
    {
      "id": "custom_7107b9d5-0e4e-4e70-b728-35f40752ffaf",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165620",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019d20af-f3ad-7624-ba29-19cddca7debc.webp",
      "image_media": {
        "alt_text": "Bathroom vanity with marble countertop, dark wood cabinets, and a large mirror.",
        "public_id": "019d20af-f3ad-7624-ba29-19cddca7debc",
        "storage_key": "property/6767906449165620/019d20af-f3ad-7624-ba29-19cddca7debc.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Modern bathroom featuring a spacious vanity, ample storage, and stylish decor. Includes a walk-in closet and a vibrant shower curtain.",
      "link": "",
      "alt_text": "Bathroom vanity with marble countertop, dark wood cabinets, and a large mirror.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019cfb45-36e5-718f-9991-3467ee17353b.webp"
    },
    {
      "id": "custom_5f6695e6-3135-44ef-921c-0c795c4ad0a7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165620",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019d20af-f80b-77a3-99ad-8854848bae0f.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed, nightstand, dresser, and mirror.",
        "public_id": "019d20af-f80b-77a3-99ad-8854848bae0f",
        "storage_key": "property/6767906449165620/019d20af-f80b-77a3-99ad-8854848bae0f.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a queen-size bed, a modern dresser with a mirror, and ample natural light. Perfect for relaxation and comfort.",
      "link": "",
      "alt_text": "Bedroom with a queen-size bed, nightstand, dresser, and mirror.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019cfb45-36e7-740d-8430-c3325176172d.webp"
    },
    {
      "id": "custom_8f050e21-077c-4df3-abc4-40a51dc3b330",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165620",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019d20af-fc60-75dd-a05d-30e4c1b47207.webp",
      "image_media": {
        "alt_text": "King-size bed with green quilt and decorative pillows, dresser, nightstand, and ceiling fan in a well-lit bedroom.",
        "public_id": "019d20af-fc60-75dd-a05d-30e4c1b47207",
        "storage_key": "property/6767906449165620/019d20af-fc60-75dd-a05d-30e4c1b47207.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Relax and unwind in this spacious bedroom, featuring a comfortable king-size bed and ample storage with a dresser and nightstand. Enjoy a bright and airy atmosphere with natural light from the window.",
      "link": "",
      "alt_text": "King-size bed with green quilt and decorative pillows, dresser, nightstand, and ceiling fan in a well-lit bedroom.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019cfb45-39c6-71ef-a5df-9d7be0211430.webp"
    },
    {
      "id": "custom_9bb3e198-b895-42b0-8767-7a526754e247",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165620",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019d20af-fcc9-7028-98e4-d9dc86786a1b.webp",
      "image_media": {
        "alt_text": "Bathroom with dark vanity, marble countertop, white sink, modern light fixture, toilet, shower curtain, and decorative artwork.",
        "public_id": "019d20af-fcc9-7028-98e4-d9dc86786a1b",
        "storage_key": "property/6767906449165620/019d20af-fcc9-7028-98e4-d9dc86786a1b.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "This apartment bathroom features a spacious vanity with a marble countertop, ample storage, and a well-lit mirror. Includes a toilet and shower area.",
      "link": "",
      "alt_text": "Bathroom with dark vanity, marble countertop, white sink, modern light fixture, toilet, shower curtain, and decorative artwork.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019cfb45-3be9-707d-b3a4-b1c2afe74a7d.webp"
    },
    {
      "id": "custom_740a79ab-89b9-4685-9f2e-fdd869ce27e5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165620",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019d20af-fec6-7738-a707-b01b2f3aeb5f.webp",
      "image_media": {
        "alt_text": "A cute painting of a dog on a beach hangs above a dog bed and food bowls in a pet-friendly apartment.",
        "public_id": "019d20af-fec6-7738-a707-b01b2f3aeb5f",
        "storage_key": "property/6767906449165620/019d20af-fec6-7738-a707-b01b2f3aeb5f.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "This apartment is pet-friendly, featuring a dedicated pet area with a cozy bed and bowls, along with a charming dog-themed painting.",
      "link": "",
      "alt_text": "A cute painting of a dog on a beach hangs above a dog bed and food bowls in a pet-friendly apartment.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019cfb45-439d-73be-8104-19ec104dd20a.webp"
    },
    {
      "id": "custom_71d6b3da-bdf6-4f6f-bbd9-d6f2b41f5a63",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165620",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019d20b0-043a-7520-9685-5220aea6c707.webp",
      "image_media": {
        "alt_text": "Modern kitchen with dark cabinets, stainless steel appliances, and marble countertops.",
        "public_id": "019d20b0-043a-7520-9685-5220aea6c707",
        "storage_key": "property/6767906449165620/019d20b0-043a-7520-9685-5220aea6c707.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Beautifully appointed kitchen featuring dark wood cabinetry, sleek stainless steel appliances including a microwave and oven, and elegant marble countertops. Perfect for cooking and entertaining.",
      "link": "",
      "alt_text": "Modern kitchen with dark cabinets, stainless steel appliances, and marble countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019cfb45-462d-71da-9d7d-3e1a48435c96.webp"
    },
    {
      "id": "custom_c8c5dbab-40cd-4cb3-abc1-57f67d5a265b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165620",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019d20b0-0b32-70d5-8ca2-0409f4abea7d.webp",
      "image_media": {
        "alt_text": "Bathroom vanity with sink, mirror, and decorative leaf plates on the wall.",
        "public_id": "019d20b0-0b32-70d5-8ca2-0409f4abea7d",
        "storage_key": "property/6767906449165620/019d20b0-0b32-70d5-8ca2-0409f4abea7d.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Bright and airy bathroom featuring a modern vanity with a marble countertop, a large mirror, and stylish leaf-shaped wall decor.",
      "link": "",
      "alt_text": "Bathroom vanity with sink, mirror, and decorative leaf plates on the wall.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019cfb45-4681-71ef-b373-2a7603a3f29f.webp"
    },
    {
      "id": "custom_a3e724fd-57b7-487a-a67c-7540fbd42095",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165620",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019d20b0-0baa-759c-aaac-514d617c26b2.webp",
      "image_media": {
        "alt_text": "Living room with a green sofa, large golden coffee table, and TV on a media console. A doorway shows a glimpse of a bedroom.",
        "public_id": "019d20b0-0baa-759c-aaac-514d617c26b2",
        "storage_key": "property/6767906449165620/019d20b0-0baa-759c-aaac-514d617c26b2.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Stylish living room with a plush sofa, modern media console, and a peek into the adjacent bedroom, offering a comfortable and inviting space.",
      "link": "",
      "alt_text": "Living room with a green sofa, large golden coffee table, and TV on a media console. A doorway shows a glimpse of a bedroom.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019cfb45-4906-7542-8939-3aae57dffa77.webp"
    },
    {
      "id": "custom_82a29070-b333-43a8-b245-95179474b1eb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165620",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019d20b0-0f4f-709f-999e-1495af6944a3.webp",
      "image_media": {
        "alt_text": "Spacious living and dining area with a modern kitchen and breakfast bar.",
        "public_id": "019d20b0-0f4f-709f-999e-1495af6944a3",
        "storage_key": "property/6767906449165620/019d20b0-0f4f-709f-999e-1495af6944a3.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Enjoy this open-concept living and dining area, seamlessly connected to a modern kitchen with a convenient breakfast bar. Perfect for entertaining or relaxing.",
      "link": "",
      "alt_text": "Spacious living and dining area with a modern kitchen and breakfast bar.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019cfb45-4a5d-7273-91e4-0c07ce320f88.webp"
    },
    {
      "id": "custom_88f99419-0925-4475-81c8-13016631f4ee",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165620",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019d20b0-10a1-701c-841b-96375abb6b1d.webp",
      "image_media": {
        "alt_text": "Dining area with a dark wood table and four grey chairs, set with blue plates.",
        "public_id": "019d20b0-10a1-701c-841b-96375abb6b1d",
        "storage_key": "property/6767906449165620/019d20b0-10a1-701c-841b-96375abb6b1d.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Enjoy meals with friends and family in this elegant dining area, featuring a stylish dark wood table and comfortable grey seating.",
      "link": "",
      "alt_text": "Dining area with a dark wood table and four grey chairs, set with blue plates.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019cfb45-4c7f-764b-bbc4-49749b72db47.webp"
    },
    {
      "id": "custom_c01891bc-dda2-487a-b045-9289e76e3154",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165620",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019d20b0-192f-737d-bed5-409cda5c6ef8.webp",
      "image_media": {
        "alt_text": "Open concept living and kitchen area with green sectional sofa, gold coffee table, and kitchen island with bar stools.",
        "public_id": "019d20b0-192f-737d-bed5-409cda5c6ef8",
        "storage_key": "property/6767906449165620/019d20b0-192f-737d-bed5-409cda5c6ef8.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Enjoy open-concept living with a spacious kitchen, comfortable living area, and modern finishes. Perfect for entertaining or relaxing.",
      "link": "",
      "alt_text": "Open concept living and kitchen area with green sectional sofa, gold coffee table, and kitchen island with bar stools.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019cfb45-4c1d-746e-9229-54aa93260f79.webp"
    },
    {
      "id": "custom_2b30bfda-4dc2-4693-b8dc-5c3ec73bbb5d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165620",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019d20b0-192e-7374-81aa-b8bb75a165c1.webp",
      "image_media": {
        "alt_text": "Modern kitchen with dark cabinets, stainless steel appliances, and marble countertops.",
        "public_id": "019d20b0-192e-7374-81aa-b8bb75a165c1",
        "storage_key": "property/6767906449165620/019d20b0-192e-7374-81aa-b8bb75a165c1.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Fully equipped kitchen featuring dark wood cabinetry, sleek marble countertops, and stainless steel appliances, perfect for everyday cooking.",
      "link": "",
      "alt_text": "Modern kitchen with dark cabinets, stainless steel appliances, and marble countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019cfb45-4d04-766c-bb05-0afc845a16a8.webp"
    },
    {
      "id": "custom_e6f64805-a4f8-4232-8e70-d95094b2f608",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165620",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019d20b0-1d8e-771d-b70e-87e0a2ba288f.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a vanity, sink, toilet, and shelving.",
        "public_id": "019d20b0-1d8e-771d-b70e-87e0a2ba288f",
        "storage_key": "property/6767906449165620/019d20b0-1d8e-771d-b70e-87e0a2ba288f.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Step into this beautifully appointed bathroom, featuring a spacious vanity with ample counter space, a modern sink, and a convenient toilet. Ample storage is available with shelving units.",
      "link": "",
      "alt_text": "Modern bathroom with a vanity, sink, toilet, and shelving.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019cfb45-54f3-775e-83fd-0ff15a1d73b4.webp"
    },
    {
      "id": "custom_f5f59b72-5944-4553-a6bd-21ddb6950753",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165620",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019d20b0-1ff2-7500-bb3e-f5021d2be49c.webp",
      "image_media": {
        "alt_text": "Modern living room with an orange sofa, coffee table, desk, and large windows.",
        "public_id": "019d20b0-1ff2-7500-bb3e-f5021d2be49c",
        "storage_key": "property/6767906449165620/019d20b0-1ff2-7500-bb3e-f5021d2be49c.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Step into comfort in this stylish living space, featuring plush seating, ample natural light from large windows, and a dedicated workspace.",
      "link": "",
      "alt_text": "Modern living room with an orange sofa, coffee table, desk, and large windows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019cfb45-57ec-75bf-ad31-a0e06f5c9515.webp"
    },
    {
      "id": "custom_9a55a8b3-4916-4ac8-a34a-74897ebdd105",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165620",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019d20b0-253d-7261-8b9f-4b55582af417.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed, nightstand, and window with pink curtains.",
        "public_id": "019d20b0-253d-7261-8b9f-4b55582af417",
        "storage_key": "property/6767906449165620/019d20b0-253d-7261-8b9f-4b55582af417.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Relax in the spacious bedroom, featuring a comfortable queen-size bed, elegant nightstand with a lamp, and large window with decorative curtains.",
      "link": "",
      "alt_text": "Bedroom with a queen-size bed, nightstand, and window with pink curtains.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019cfb45-5823-72fa-9c7e-5dfcb3bfd312.webp"
    },
    {
      "id": "custom_d73f7737-31d1-4abb-b31b-19e58616a160",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165620",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019d20b0-2718-7498-a561-34867054d9c4.webp",
      "image_media": {
        "alt_text": "Round dining table with four chairs, floor lamp, and large decorative vase.",
        "public_id": "019d20b0-2718-7498-a561-34867054d9c4",
        "storage_key": "property/6767906449165620/019d20b0-2718-7498-a561-34867054d9c4.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Charming dining area featuring a round wooden table with four upholstered chairs, accented by a stylish floor lamp and a large, eye-catching decorative vase. Brightly lit by abundant natural light from large windows.",
      "link": "",
      "alt_text": "Round dining table with four chairs, floor lamp, and large decorative vase.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019cfb45-5b3d-7508-8ea0-0d97343ef5d4.webp"
    },
    {
      "id": "custom_5ec8260f-9a17-420c-9dfb-29830022bfa6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165620",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019d20b0-277f-749c-a2ee-a9007f23e385.webp",
      "image_media": {
        "alt_text": "Dining area with a round table, four chairs, and large windows with blinds and patterned curtains.",
        "public_id": "019d20b0-277f-749c-a2ee-a9007f23e385",
        "storage_key": "property/6767906449165620/019d20b0-277f-749c-a2ee-a9007f23e385.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Enjoy meals in this bright dining area, featuring a round table, comfortable seating, and large windows that let in plenty of natural light.",
      "link": "",
      "alt_text": "Dining area with a round table, four chairs, and large windows with blinds and patterned curtains.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019cfb45-5bbb-76df-877b-c92692ad7029.webp"
    },
    {
      "id": "custom_e86bf1f1-5353-4bbd-9c86-db12d06cea61",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165620",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019d20b0-2a8a-716b-b6e0-02cb54fcc44b.webp",
      "image_media": {
        "alt_text": "Living room with a TV, a large sofa, and a coffee table.",
        "public_id": "019d20b0-2a8a-716b-b6e0-02cb54fcc44b",
        "storage_key": "property/6767906449165620/019d20b0-2a8a-716b-b6e0-02cb54fcc44b.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "A beautifully furnished living room featuring a TV, a comfortable sofa, a stylish coffee table, and large windows offering natural light.",
      "link": "",
      "alt_text": "Living room with a TV, a large sofa, and a coffee table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019cfb45-5bdc-72d5-93b4-546aaf90d6f1.webp"
    },
    {
      "id": "custom_8c31afea-5746-4557-8ff6-40f322cbf61f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165620",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019d20b0-3488-73dd-84b3-b6f2405b7f59.webp",
      "image_media": {
        "alt_text": "Living room with a TV, sofa, chairs, coffee table, and large windows.",
        "public_id": "019d20b0-3488-73dd-84b3-b6f2405b7f59",
        "storage_key": "property/6767906449165620/019d20b0-3488-73dd-84b3-b6f2405b7f59.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Spacious living room featuring a modern entertainment center, comfortable seating, and ample natural light from large windows.",
      "link": "",
      "alt_text": "Living room with a TV, sofa, chairs, coffee table, and large windows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019cfb45-601f-7004-a655-4f9dc44ec1bf.webp"
    },
    {
      "id": "custom_fdb8f1ab-60a0-41aa-ae54-c7f2fc7946a3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165620",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019d20b0-351d-76cf-94f6-cbd13c9a0ffe.webp",
      "image_media": {
        "alt_text": "King-sized bed with white linens and colorful pillows in a bedroom with a large round mirror and wooden dresser.",
        "public_id": "019d20b0-351d-76cf-94f6-cbd13c9a0ffe",
        "storage_key": "property/6767906449165620/019d20b0-351d-76cf-94f6-cbd13c9a0ffe.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a king-sized bed, elegant headboard, and a large round mirror reflecting the room. Includes a dresser and ample closet space.",
      "link": "",
      "alt_text": "King-sized bed with white linens and colorful pillows in a bedroom with a large round mirror and wooden dresser.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019cfb45-5f87-7447-9b04-2c66b877ea88.webp"
    },
    {
      "id": "custom_dd9cb2ea-5c9e-4fb9-b8e8-3864a16e3e85",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165620",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019d20b0-351d-76cf-94f6-ccb55cbad5e5.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a single vanity, toilet, and bathtub with shower curtain.",
        "public_id": "019d20b0-351d-76cf-94f6-ccb55cbad5e5",
        "storage_key": "property/6767906449165620/019d20b0-351d-76cf-94f6-ccb55cbad5e5.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Enjoy the modern design of this bathroom, featuring a spacious vanity, elegant fixtures, and a relaxing bathtub with a decorative shower curtain.",
      "link": "",
      "alt_text": "Modern bathroom with a single vanity, toilet, and bathtub with shower curtain.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019cfb45-67ea-77a9-acb6-df0aaf3dfd22.webp"
    },
    {
      "id": "custom_a67db71b-0878-4770-ab11-e1ab4d00a98e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165620",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019d20b0-364f-73ed-98c8-5b849c1e11bd.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, white cabinets, and granite countertops.",
        "public_id": "019d20b0-364f-73ed-98c8-5b849c1e11bd",
        "storage_key": "property/6767906449165620/019d20b0-364f-73ed-98c8-5b849c1e11bd.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Spacious and modern kitchen featuring stainless steel appliances, ample cabinet storage, and sleek granite countertops. Perfect for cooking and entertaining.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances, white cabinets, and granite countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019cfb45-67d2-712e-8e96-9a4ed570819f.webp"
    },
    {
      "id": "custom_5e783594-e202-4ab9-a1ed-9bf8185459dd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165620",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019d20b0-3f55-73fa-a652-213b7e6574c8.webp",
      "image_media": {
        "alt_text": "Living room and kitchen area of an apartment.",
        "public_id": "019d20b0-3f55-73fa-a652-213b7e6574c8",
        "storage_key": "property/6767906449165620/019d20b0-3f55-73fa-a652-213b7e6574c8.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "A beautifully staged living room and kitchen area, featuring a comfortable sofa, elegant armchair, coffee table, television, and a modern kitchen with stainless steel appliances.",
      "link": "",
      "alt_text": "Living room and kitchen area of an apartment.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019cfb45-6b77-76ef-b6b1-c68f4fb4f6ff.webp"
    },
    {
      "id": "custom_05b15e69-2c56-4256-8e84-1fe4ee73a959",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165620",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019d20b0-404a-7209-bfd1-533445da2f15.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a vanity, sink, toilet, and shower/tub.",
        "public_id": "019d20b0-404a-7209-bfd1-533445da2f15",
        "storage_key": "property/6767906449165620/019d20b0-404a-7209-bfd1-533445da2f15.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Step into a clean and modern bathroom featuring a sleek vanity, a deep soaking tub with a shower, and ample storage.",
      "link": "",
      "alt_text": "Modern bathroom with a vanity, sink, toilet, and shower/tub.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019cfb45-6c8a-73a5-adca-0f09c5adb350.webp"
    },
    {
      "id": "custom_51a5feb6-ada4-45bd-9986-ad19c4eaba02",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165620",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019d20b0-4026-765c-8db7-e74386a40dc8.webp",
      "image_media": {
        "alt_text": "Modern bathroom with white vanity, marble countertop, large mirror, and a lemon-themed shower curtain.",
        "public_id": "019d20b0-4026-765c-8db7-e74386a40dc8",
        "storage_key": "property/6767906449165620/019d20b0-4026-765c-8db7-e74386a40dc8.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Refresh and unwind in this stylish bathroom, featuring a spacious vanity with marble countertops, a large mirror, and a vibrant lemon-patterned shower curtain for a touch of nature-inspired design.",
      "link": "",
      "alt_text": "Modern bathroom with white vanity, marble countertop, large mirror, and a lemon-themed shower curtain.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019cfb45-6dca-7128-ac12-84726a904910.webp"
    },
    {
      "id": "custom_4b2ad232-7547-45d3-842d-2eb6f19a391a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165620",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019d20b0-4133-76f6-97d4-2359fd9dd66a.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, white cabinets, and a granite countertop island.",
        "public_id": "019d20b0-4133-76f6-97d4-2359fd9dd66a",
        "storage_key": "property/6767906449165620/019d20b0-4133-76f6-97d4-2359fd9dd66a.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Experience comfort and style in our modern apartments. This kitchen features sleek white cabinetry, a granite island perfect for casual dining, and stainless steel appliances, making meal prep a breeze.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances, white cabinets, and a granite countertop island.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019cfb45-70af-75d9-bec4-cfc1066279de.webp"
    },
    {
      "id": "custom_ed7bb53d-ebca-4a6f-a933-8981df41f063",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165620",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019d20b0-492a-735c-bd4c-b2da6d84be14.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and white cabinets.",
        "public_id": "019d20b0-492a-735c-bd4c-b2da6d84be14",
        "storage_key": "property/6767906449165620/019d20b0-492a-735c-bd4c-b2da6d84be14.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "View of a modern kitchen featuring stainless steel appliances, white cabinetry, and granite countertops. Perfect for home chefs.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances and white cabinets.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019cfb45-7372-72c9-83d8-85962e531274.webp"
    },
    {
      "id": "custom_346c3d45-6616-44e4-918c-1929eee16928",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165620",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019d20b0-4b9f-7136-9dab-39d0b85a7dc9.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a vanity, sink, toilet, and shower with a striped curtain.",
        "public_id": "019d20b0-4b9f-7136-9dab-39d0b85a7dc9",
        "storage_key": "property/6767906449165620/019d20b0-4b9f-7136-9dab-39d0b85a7dc9.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Experience comfort and style in this beautifully appointed bathroom, featuring a sleek vanity, modern fixtures, and a relaxing shower.",
      "link": "",
      "alt_text": "Modern bathroom with a vanity, sink, toilet, and shower with a striped curtain.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019cfb45-75a5-779e-8460-f5ccc96b49ad.webp"
    },
    {
      "id": "custom_e1eb148f-9283-404e-b16b-49d4404a656e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165620",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019d20b0-4baa-7527-be6a-465407e8c240.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed, nightstand, and dresser.",
        "public_id": "019d20b0-4baa-7527-be6a-465407e8c240",
        "storage_key": "property/6767906449165620/019d20b0-4baa-7527-be6a-465407e8c240.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Cozy bedroom featuring a queen-size bed with blue and white striped bedding, a wooden nightstand with a lamp and decorative items, and a dresser. This room offers a comfortable and stylish living space.",
      "link": "",
      "alt_text": "Bedroom with a queen-size bed, nightstand, and dresser.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019cfb45-75d1-710d-a471-14068de2cf1f.webp"
    },
    {
      "id": "custom_da157cf3-6aaa-461c-b3d1-f2fb6d208a90",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165620",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019d20b0-4f0d-7691-b2de-b4ce1bc4f3b7.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and a subway tile backsplash.",
        "public_id": "019d20b0-4f0d-7691-b2de-b4ce1bc4f3b7",
        "storage_key": "property/6767906449165620/019d20b0-4f0d-7691-b2de-b4ce1bc4f3b7.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Experience gourmet cooking in this beautifully appointed kitchen, featuring sleek white cabinetry, granite countertops, and state-of-the-art stainless steel appliances.",
      "link": "",
      "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and a subway tile backsplash.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019cfb45-7926-72f0-b841-37319ae15ad5.webp"
    },
    {
      "id": "custom_5fe22a7c-e7e0-4653-b9a1-5bbec06462c8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165620",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019d20b0-5653-7079-a12b-83931b5521d0.webp",
      "image_media": {
        "alt_text": "Empty walk-in closet with wire shelving and wicker baskets.",
        "public_id": "019d20b0-5653-7079-a12b-83931b5521d0",
        "storage_key": "property/6767906449165620/019d20b0-5653-7079-a12b-83931b5521d0.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Spacious walk-in closet featuring ample wire shelving for storage and decorative wicker baskets on the floor.",
      "link": "",
      "alt_text": "Empty walk-in closet with wire shelving and wicker baskets.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019cfb45-734b-711c-8332-6cf3d38cb819.webp"
    },
    {
      "id": "custom_ef2e058d-8441-4c80-b0f3-2c2560537572",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165620",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019d20b0-5815-70bb-a0aa-1b7ed83f707f.webp",
      "image_media": {
        "alt_text": "Empty walk-in closet with wire shelving and two woven baskets.",
        "public_id": "019d20b0-5815-70bb-a0aa-1b7ed83f707f",
        "storage_key": "property/6767906449165620/019d20b0-5815-70bb-a0aa-1b7ed83f707f.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Spacious walk-in closet featuring ample wire shelving and two decorative woven baskets, perfect for storage and organization.",
      "link": "",
      "alt_text": "Empty walk-in closet with wire shelving and two woven baskets.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019cfb45-585f-712a-9bfc-e6616ec2cb65.webp"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_527e204f-98db-489f-90e7-380fa74a28f1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165620",
      "source": "custom",
      "poi_name": "Texas Roadhouse",
      "poi_type": "Restaurants",
      "poi_address": "624 N General Bruce Dr, Temple, TX 76504, USA",
      "poi_short_description": "Steaks, ribs, and other American eats served in a casual setting with line dancing and a jukebox.",
      "poi_long_description": "People say this steakhouse serves delicious steaks, ribs, and rolls. They also highlight the affordable prices, fun atmosphere, and attentive service.\n\nSome reviews mention the music can be loud.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019d2709-5374-762c-bcb0-0c7ce9ba3eeb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-5374-762c-bcb0-0c7ce9ba3eeb",
        "storage_key": "property/6767906449165620/019d2709-5374-762c-bcb0-0c7ce9ba3eeb.webp",
        "width": 1280,
        "height": 598
      },
      "poi_business_url": "https://www.texasroadhouse.com/locations/texas/temple?utm_source=listing&utm_medium=search",
      "poi_directions_map_url": "https://maps.google.com/?cid=3538844603353276690&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "texas-roadhouse",
      "poi_latitude": "31.1090177",
      "poi_longitude": "-97.3580544",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 46 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 254-773-0033",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019d2709-820b-7564-b68a-896b9bde345c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-820b-7564-b68a-896b9bde345c",
        "storage_key": "property/6767906449165620/019d2709-820b-7564-b68a-896b9bde345c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJvfW7jIVrRYYREiEuymqAHDE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_770de20b-24d2-4ac4-882e-330601cca681",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165620",
      "source": "custom",
      "poi_name": "Miller's Smokehouse",
      "poi_type": "Restaurants",
      "poi_address": "300 E Central Ave, Belton, TX 76513, USA",
      "poi_short_description": "Down-home BBQ place serving brisket, sausage & ribs with classic sides, desserts & craft beer.",
      "poi_long_description": "People say this barbecue restaurant serves amazing brisket, sausage, and pulled pork, as well as delicious sides like potato salad and mac and cheese. They highlight the fast service, friendly staff, and clean atmosphere. They also like the reasonable prices and generous portions.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019d2709-52ec-709d-9774-03c70b543b0d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-52ec-709d-9774-03c70b543b0d",
        "storage_key": "property/6767906449165620/019d2709-52ec-709d-9774-03c70b543b0d.webp",
        "width": 1280,
        "height": 818
      },
      "poi_business_url": "http://www.millerssmokehouse.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7679348725931195452&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "millers-smokehouse",
      "poi_latitude": "31.056148",
      "poi_longitude": "-97.461608",
      "poi_miles_from_property": "7.4",
      "poi_walking_minutes": "2 hours 43 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 254-939-5500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019d2709-820b-7564-b68a-896b9bde345c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-820b-7564-b68a-896b9bde345c",
        "storage_key": "property/6767906449165620/019d2709-820b-7564-b68a-896b9bde345c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJn-pEl3JARYYRPDx6s_qGkmo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barbecue_restaurant"
    },
    {
      "id": "custom_e6835043-c32c-41be-9267-9d4447cbb9b1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165620",
      "source": "custom",
      "poi_name": "Chick-fil-A",
      "poi_type": "Restaurants",
      "poi_address": "114 N 31st St, Temple, TX 76504, USA",
      "poi_short_description": "Fast-food chain known for its chicken sandwiches, waffle potato fries, and breakfast, plus a playground.",
      "poi_long_description": "People say this fast food restaurant serves hot, fresh, and tasty chicken sandwiches and fries. They highlight the quick and correct orders, and the comfortable dining room atmosphere. They also like the friendly, helpful, and efficient staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019d2709-5324-706e-aad7-06ca4adac989.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-5324-706e-aad7-06ca4adac989",
        "storage_key": "property/6767906449165620/019d2709-5324-706e-aad7-06ca4adac989.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.chick-fil-a.com/locations/tx/north-31st-street?utm_source=yext&utm_medium=link",
      "poi_directions_map_url": "https://maps.google.com/?cid=14566324821928074087&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "chick-fil-a",
      "poi_latitude": "31.1030831",
      "poi_longitude": "-97.357272",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 24 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 254-771-2020",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019d2709-820b-7564-b68a-896b9bde345c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-820b-7564-b68a-896b9bde345c",
        "storage_key": "property/6767906449165620/019d2709-820b-7564-b68a-896b9bde345c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJH4Mx4oNrRYYRZ1v69T_7Jco",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_926aacee-7d2a-4129-96bb-2a2fda2e7676",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165620",
      "source": "custom",
      "poi_name": "Raising Cane's Chicken Fingers",
      "poi_type": "Restaurants",
      "poi_address": "2304 S 31st St, Temple, TX 76504, USA",
      "poi_short_description": "Chain for cooked-to-order meals featuring crispy chicken fingers, fries and Texas toast.",
      "poi_long_description": "Diners say this fast food restaurant serves up delicious chicken fingers with the signature Cane's sauce, and they praise the fast and friendly service. They also highlight the great value for families, with meals that can feed four adults for around $43.\n\nSome reviews mention the drive-thru staff can be impolite.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019d2709-52bd-75e0-84f5-1c4ba4a5001c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-52bd-75e0-84f5-1c4ba4a5001c",
        "storage_key": "property/6767906449165620/019d2709-52bd-75e0-84f5-1c4ba4a5001c.webp",
        "width": 720,
        "height": 720
      },
      "poi_business_url": "https://locations.raisingcanes.com/tx/temple/2304-s-31st-street",
      "poi_directions_map_url": "https://maps.google.com/?cid=7140327766015520526&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "raising-canes-chicken-fingers",
      "poi_latitude": "31.07842909999999",
      "poi_longitude": "-97.3665503",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 254-771-4082",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019d2709-820b-7564-b68a-896b9bde345c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-820b-7564-b68a-896b9bde345c",
        "storage_key": "property/6767906449165620/019d2709-820b-7564-b68a-896b9bde345c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJe73SDmlrRYYRDq82qUWKF2M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_b6457e04-fc43-4761-94e4-6d8870c5b383",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165620",
      "source": "custom",
      "poi_name": "LongHorn Steakhouse",
      "poi_type": "Restaurants",
      "poi_address": "4507 S General Bruce Dr, Temple, TX 76502, USA",
      "poi_short_description": "Casual chain serving various cuts of steak, burgers, grilled chicken and seafood, plus beer and cocktails.",
      "poi_long_description": "People say this steakhouse serves delicious steaks, chicken fried steak, and shrimp appetizers. They also highlight the attentive and friendly staff, and the fast service.\n\nOther reviews mention the food can be overcooked.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019d2709-5802-7148-8c61-f15a86a953bb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-5802-7148-8c61-f15a86a953bb",
        "storage_key": "property/6767906449165620/019d2709-5802-7148-8c61-f15a86a953bb.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.longhornsteakhouse.com/locations/tx/temple/temple/5535?cmpid=br:lh_ag:ie_ch:loc_ca:LHGMB_sn:gmb_gt:temple-tx-5535_pl:locurl_rd:1467",
      "poi_directions_map_url": "https://maps.google.com/?cid=1074958954696163717&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "longhorn-steakhouse",
      "poi_latitude": "31.0863969",
      "poi_longitude": "-97.398142",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 22 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 254-774-1248",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019d2709-820b-7564-b68a-896b9bde345c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-820b-7564-b68a-896b9bde345c",
        "storage_key": "property/6767906449165620/019d2709-820b-7564-b68a-896b9bde345c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_dFj5PxqRYYRhUHKUnkF6w4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_097e3da6-2238-4ae8-8cee-bcf5e0f3e140",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165620",
      "source": "custom",
      "poi_name": "H-E-B plus!",
      "poi_type": "Shopping & Retail",
      "poi_address": "2509 N Main St, Belton, TX 76513, USA",
      "poi_short_description": "Clean grocery store and bakery chain with a pharmacy and friendly staff.",
      "poi_long_description": "People say this grocery store offers a wide variety of fresh produce, good quality grocery items, and tasty options from the bakery and deli. They highlight the reasonable prices, clean store, and convenient online ordering and curbside pickup. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019d2709-57b9-76cd-8a0b-c8c94d3a828b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-57b9-76cd-8a0b-c8c94d3a828b",
        "storage_key": "property/6767906449165620/019d2709-57b9-76cd-8a0b-c8c94d3a828b.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.heb.com/heb-store/US/tx/belton/belton-h-e-b-plus--39?utm_source=google&utm_medium=organic&utm_campaign=gmb_stores",
      "poi_directions_map_url": "https://maps.google.com/?cid=7777259760483035562&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "h-e-b-plus",
      "poi_latitude": "31.080455",
      "poi_longitude": "-97.454559",
      "poi_miles_from_property": "7.9",
      "poi_walking_minutes": "2 hours 55 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 254-939-0856",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019d2709-81f3-7379-99ea-455ddb013adb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-81f3-7379-99ea-455ddb013adb",
        "storage_key": "property/6767906449165620/019d2709-81f3-7379-99ea-455ddb013adb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ11OhSThARYYRqumH5Ytg7ms",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_50238967-31d2-45a6-b465-67f63b46624f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165620",
      "source": "custom",
      "poi_name": "The Home Depot",
      "poi_type": "Shopping & Retail",
      "poi_address": "3550 S General Bruce Dr Building B100, Temple, TX 76504, USA",
      "poi_short_description": "Home-improvement chain supplying tools, appliances, building materials, and more.",
      "poi_long_description": "People say this home improvement store offers a wide selection of products. They also highlight the helpful and knowledgeable staff, and the reasonable prices.\n\nOther reviews mention the carts can be difficult to find.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019d2709-5883-70a0-9c32-d3f6180c94e6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-5883-70a0-9c32-d3f6180c94e6",
        "storage_key": "property/6767906449165620/019d2709-5883-70a0-9c32-d3f6180c94e6.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://www.homedepot.com/l/Temple/TX/Temple/76504/6863?emt=MSGMBGoogleMaps",
      "poi_directions_map_url": "https://maps.google.com/?cid=14443536008298783890&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-home-depot",
      "poi_latitude": "31.0948095",
      "poi_longitude": "-97.382614",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 254-773-3870",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019d2709-821e-774d-9a94-06d6cb0875c4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-821e-774d-9a94-06d6cb0875c4",
        "storage_key": "property/6767906449165620/019d2709-821e-774d-9a94-06d6cb0875c4.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJEem2aQZrRYYRkmQ2c3m_ccg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_6d9fb23d-b0d3-4290-9a66-6903d75b8f7e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165620",
      "source": "custom",
      "poi_name": "H-E-B",
      "poi_type": "Shopping & Retail",
      "poi_address": "3002 S 31st St, Temple, TX 76502, USA",
      "poi_short_description": "Branch of the Texas-born chain offering a medium-tier selection of groceries, along with in-store bakery, flowers and pharmacy departments.",
      "poi_long_description": "People say this grocery store offers a wide selection of fresh produce, a great bakery, and a variety of food options. They highlight the reasonable prices and the clean, well-organized store. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019d2709-586b-762a-90f5-8c30739207a8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-586b-762a-90f5-8c30739207a8",
        "storage_key": "property/6767906449165620/019d2709-586b-762a-90f5-8c30739207a8.webp",
        "width": 1280,
        "height": 738
      },
      "poi_business_url": "https://www.heb.com/heb-store/US/tx/temple/31st-and-market-h-e-b-182?utm_source=google&utm_medium=organic&utm_campaign=gmb_stores",
      "poi_directions_map_url": "https://maps.google.com/?cid=202324921833876744&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "h-e-b",
      "poi_latitude": "31.07192899999999",
      "poi_longitude": "-97.370108",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 254-778-4820",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019d2709-81f3-7379-99ea-455ddb013adb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-81f3-7379-99ea-455ddb013adb",
        "storage_key": "property/6767906449165620/019d2709-81f3-7379-99ea-455ddb013adb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJjYmF_0BrRYYRCO0dx3HNzgI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_1993ceef-2476-45be-87a0-c7bfe5027946",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165620",
      "source": "custom",
      "poi_name": "Lowe's Home Improvement",
      "poi_type": "Shopping & Retail",
      "poi_address": "605 SW H K Dodgen Loop, Temple, TX 76502, USA",
      "poi_short_description": "Home improvement chain retailer selling tools and furniture as well as appliances.",
      "poi_long_description": "People say this home improvement store offers a wide selection of products. They also highlight the helpful and friendly staff, and the free delivery and haul-off service.\n\nOther reviews mention the delivery service can be unreliable.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019d2709-5cc4-76f6-a614-e2c3ba9f748c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-5cc4-76f6-a614-e2c3ba9f748c",
        "storage_key": "property/6767906449165620/019d2709-5cc4-76f6-a614-e2c3ba9f748c.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.lowes.com/store/TX-Temple/0221?cm_mmc=lod-_-c-_-lcl-_-awr-_-yxt-_-go-_-221-_-na-_-0-_-0&y_source=1_MTE4Mjk0Ny03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=6918425852965198866&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "lowes-home-improvement",
      "poi_latitude": "31.06965599999999",
      "poi_longitude": "-97.361582",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 254-778-2090",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019d2709-821e-774d-9a94-06d6cb0875c4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-821e-774d-9a94-06d6cb0875c4",
        "storage_key": "property/6767906449165620/019d2709-821e-774d-9a94-06d6cb0875c4.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJV7vgplxrRYYREpzeaqgvA2A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_4e744b3a-6a75-4a84-bc6b-e0eeffa3826b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165620",
      "source": "custom",
      "poi_name": "Temple College",
      "poi_type": "Education",
      "poi_address": "2600 S 1st St, Temple, TX 76504, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019d2709-5c72-7418-8abb-3a1b892a27b1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-5c72-7418-8abb-3a1b892a27b1",
        "storage_key": "property/6767906449165620/019d2709-5c72-7418-8abb-3a1b892a27b1.webp",
        "width": 1280,
        "height": 824
      },
      "poi_business_url": "http://www.templejc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4793458920571701676&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "temple-college",
      "poi_latitude": "31.071874",
      "poi_longitude": "-97.3515972",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 254-298-8282",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019d2709-8234-712b-8188-c9cee6569b8e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-8234-712b-8188-c9cee6569b8e",
        "storage_key": "property/6767906449165620/019d2709-8234-712b-8188-c9cee6569b8e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJe6Us6qFsRYYRrIkazn3JhUI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_79cf438a-3721-461c-b7ba-305dec2ea7a4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165620",
      "source": "custom",
      "poi_name": "City of Temple Public Library",
      "poi_type": "Education",
      "poi_address": "100 W Adams Ave, Temple, TX 76501, USA",
      "poi_short_description": "Public library with a selection of books for adults and children, a kids' area, and helpful staff.",
      "poi_long_description": "People say this public library offers a wide selection of books, free water fountains with water bottle fillers, and access to CloudLib and Libby. They highlight the modern and classic charm, and the accessibility for mobility aids. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019d2709-5d1e-7665-ac2e-380b37f076be.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-5d1e-7665-ac2e-380b37f076be",
        "storage_key": "property/6767906449165620/019d2709-5d1e-7665-ac2e-380b37f076be.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://exploretpl.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10791532723185062354&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "city-of-temple-public-library",
      "poi_latitude": "31.09835559999999",
      "poi_longitude": "-97.3421056",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 254-298-5556",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019d2709-8234-712b-8188-c9cee6569b8e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-8234-712b-8188-c9cee6569b8e",
        "storage_key": "property/6767906449165620/019d2709-8234-712b-8188-c9cee6569b8e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJn-2ek4dsRYYR0hFz89U5w5U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_761bff32-d765-4f38-af50-1b2aea988894",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165620",
      "source": "custom",
      "poi_name": "Meridith-Dunbar Early Childhood Academy",
      "poi_type": "Education",
      "poi_address": "1717 E Avenue J, Temple, TX 76501, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019d2709-5d3f-773c-a0d6-b61fcb98ab8d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-5d3f-773c-a0d6-b61fcb98ab8d",
        "storage_key": "property/6767906449165620/019d2709-5d3f-773c-a0d6-b61fcb98ab8d.webp",
        "width": 1280,
        "height": 402
      },
      "poi_business_url": "http://meridith-dunbar.tisd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14870886663730647324&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "meridith-dunbar-early-childhood-academy",
      "poi_latitude": "31.0814032",
      "poi_longitude": "-97.3277195",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 26 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 254-215-6700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019d2709-8234-712b-8188-c9cee6569b8e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-8234-712b-8188-c9cee6569b8e",
        "storage_key": "property/6767906449165620/019d2709-8234-712b-8188-c9cee6569b8e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ5Sslp-tsRYYRHFHCnqEAYM4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_1d3d074d-c16b-4001-a532-9858c180e884",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165620",
      "source": "custom",
      "poi_name": "Summer Fun Water Park",
      "poi_type": "Entertainment",
      "poi_address": "1410 Waco Rd, Belton, TX 76513, USA",
      "poi_short_description": "Water park with a lazy river, a kiddie pool, and a restaurant, plus volleyball.",
      "poi_long_description": "People say this water park offers a lazy river, slides, and a pool, and is a fun place for families. They also highlight the affordable season passes, convenient location, and friendly staff.\n\nOther reviews mention the water can be cold.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019d2709-6146-76fb-b9df-48bec86f5dd4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-6146-76fb-b9df-48bec86f5dd4",
        "storage_key": "property/6767906449165620/019d2709-6146-76fb-b9df-48bec86f5dd4.webp",
        "width": 1097,
        "height": 1097
      },
      "poi_business_url": "https://www.summerfunwaterpark.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10953112072134897060&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "summer-fun-water-park",
      "poi_latitude": "31.0666988",
      "poi_longitude": "-97.4432838",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 14 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 254-939-0366",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019d2709-8668-77db-bc1e-3fce023a462b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-8668-77db-bc1e-3fce023a462b",
        "storage_key": "property/6767906449165620/019d2709-8668-77db-bc1e-3fce023a462b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJR-ciyh5ARYYRpK2kxGVFAZg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "water_park"
    },
    {
      "id": "custom_b0bb1398-afbd-42f6-8379-cde686dc9d02",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165620",
      "source": "custom",
      "poi_name": "Lions Junction Family Water Park",
      "poi_type": "Entertainment",
      "poi_address": "5000 S 5th St, Temple, TX 76502, USA",
      "poi_short_description": "Small water park featuring a lazy river, rock wall and splash pad as well as slides.",
      "poi_long_description": "People say this water park offers a lazy river, whirlpool, splash pad, swimming pool, and slides. They also highlight the economical prices, friendly staff, and clean facilities.\n\nOther reviews mention the hours can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019d2709-6214-7572-bc70-49a7848f7f55.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-6214-7572-bc70-49a7848f7f55",
        "storage_key": "property/6767906449165620/019d2709-6214-7572-bc70-49a7848f7f55.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.lionsjunction.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14979284997054647922&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "lions-junction-family-water-park",
      "poi_latitude": "31.0454095",
      "poi_longitude": "-97.3639572",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 254-298-5920",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019d2709-8668-77db-bc1e-3fce023a462b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-8668-77db-bc1e-3fce023a462b",
        "storage_key": "property/6767906449165620/019d2709-8668-77db-bc1e-3fce023a462b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJbVrTh7EURYYRcs7HVlcc4c8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "water_park"
    },
    {
      "id": "custom_f2230e53-a2d0-4ace-a0ca-1eb0e0a6cae6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165620",
      "source": "custom",
      "poi_name": "Xtreme Jump Adventure Park",
      "poi_type": "Entertainment",
      "poi_address": "3111 S 31st St Suite 6504 B, Temple, TX 76502, USA",
      "poi_short_description": "Family-friendly amusement center that offers trampolines for jumping, rock climbing and arcade games.",
      "poi_long_description": "Visitors say this amusement park offers a wide variety of activities, including laser tag, go-karts, trampolines, a play area, a mirror maze, an arcade, and bowling. They like that it's a great place for families with kids of all ages, and that the staff is friendly and welcoming.\n\nSome reviews mention the customer service can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019d2709-61bc-7591-a89c-fcc30c92173d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-61bc-7591-a89c-fcc30c92173d",
        "storage_key": "property/6767906449165620/019d2709-61bc-7591-a89c-fcc30c92173d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://xtremejumptemple.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1318001968917807610&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "xtreme-jump-adventure-park",
      "poi_latitude": "31.0697226",
      "poi_longitude": "-97.3660137",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 254-314-2117",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019d2709-8668-77db-bc1e-3fce023a462b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-8668-77db-bc1e-3fce023a462b",
        "storage_key": "property/6767906449165620/019d2709-8668-77db-bc1e-3fce023a462b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJZ36hGrprRYYR-oGcws57ShI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "custom_70d56c07-b625-4992-af32-e594719149c4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165620",
      "source": "custom",
      "poi_name": "Temple Railroad & Heritage Museum",
      "poi_type": "Entertainment",
      "poi_address": "315 W Avenue B, Temple, TX 76501, USA",
      "poi_short_description": "Permanent and changing exhibits on railroading are housed in the historic Santa Fe Depot.",
      "poi_long_description": "People say this museum offers train cars to explore and a scavenger hunt. They highlight the affordable admission and fun, family-oriented vibe. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019d2709-62f8-7784-8172-5cc777bbc945.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-62f8-7784-8172-5cc777bbc945",
        "storage_key": "property/6767906449165620/019d2709-62f8-7784-8172-5cc777bbc945.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.templerrhm.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12854046730207160332&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "temple-railroad--heritage-museum",
      "poi_latitude": "31.09566939999999",
      "poi_longitude": "-97.3451861",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 254-298-5172",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019d2709-8663-779d-9de7-e6100e0b07be.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-8663-779d-9de7-e6100e0b07be",
        "storage_key": "property/6767906449165620/019d2709-8663-779d-9de7-e6100e0b07be.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJi85f3YZsRYYRDOhEwGW_YrI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_720ca514-f068-479d-9be8-f9176ab90d29",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165620",
      "source": "custom",
      "poi_name": "Temple Children's Museum",
      "poi_type": "Entertainment",
      "poi_address": "11 N 4th St, Temple, TX 76501, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this museum offers a variety of engaging and creative activities for young children. They highlight the fun and educational experience, and the clean and well-maintained environment. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019d2709-668b-77f9-85c2-d6d6777df6c5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-668b-77f9-85c2-d6d6777df6c5",
        "storage_key": "property/6767906449165620/019d2709-668b-77f9-85c2-d6d6777df6c5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.templechildrensmuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8680506965749673616&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "temple-childrens-museum",
      "poi_latitude": "31.0966963",
      "poi_longitude": "-97.3387952",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 15 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 254-500-7617",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019d2709-8663-779d-9de7-e6100e0b07be.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-8663-779d-9de7-e6100e0b07be",
        "storage_key": "property/6767906449165620/019d2709-8663-779d-9de7-e6100e0b07be.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9z4VDndtRYYRkC7QExhbd3g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_d6982924-41b8-45ad-9d41-07de86f6c15d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165620",
      "source": "custom",
      "poi_name": "Crunch Fitness - Temple",
      "poi_type": "Health and Wellness",
      "poi_address": "4501 S General Bruce Dr, Temple, TX 76502, USA",
      "poi_short_description": "Spacious gym featuring group classes, an array of cardio and weight equipment, and saunas.",
      "poi_long_description": "People say this gym offers a wide variety of equipment, including free weights, cardio machines, and cable machines, as well as amenities like a sauna and hydrotherapy massage beds.\n\nOther reviews mention the membership can be expensive and the cancellation process can be difficult.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019d2709-66af-760f-a86d-de535a316019.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-66af-760f-a86d-de535a316019",
        "storage_key": "property/6767906449165620/019d2709-66af-760f-a86d-de535a316019.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.crunch.com/locations/temple",
      "poi_directions_map_url": "https://maps.google.com/?cid=2375418636632549693&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "crunch-fitness---temple",
      "poi_latitude": "31.0863767",
      "poi_longitude": "-97.3964173",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 21 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 254-677-8700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019d2709-8668-77db-bc1e-3fce023a462b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-8668-77db-bc1e-3fce023a462b",
        "storage_key": "property/6767906449165620/019d2709-8668-77db-bc1e-3fce023a462b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJT7XqPS5rRYYRPWlTHaou9yA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_fc2d576a-8ae3-4921-a0c4-f21d404b54c6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165620",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "3111 S 31st St, Temple, TX 76502, USA",
      "poi_short_description": "Familiar chain of gyms featuring clean workout facilities and friendly service.",
      "poi_long_description": "People say this gym offers a wide variety of workout options and equipment. They highlight the clean facilities and well-maintained equipment. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019d2709-6763-7209-b670-55df149bb5f6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-6763-7209-b670-55df149bb5f6",
        "storage_key": "property/6767906449165620/019d2709-6763-7209-b670-55df149bb5f6.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/temple-tx?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=6147145649810432872&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "31.070895",
      "poi_longitude": "-97.3674835",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 254-477-6777",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019d2709-8668-77db-bc1e-3fce023a462b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-8668-77db-bc1e-3fce023a462b",
        "storage_key": "property/6767906449165620/019d2709-8668-77db-bc1e-3fce023a462b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJlRdHDUZrRYYRaOOJR2YMT1U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_a2ed8dde-920e-4bab-901e-20989189b7e9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165620",
      "source": "custom",
      "poi_name": "T3 Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "2329 S 57th St, Temple, TX 76504, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this gym has fantastic equipment, a great energy, and is very clean. They also highlight the friendly and helpful staff, and the convenient location.\n\nSome reviews mention the membership cancellation process can be difficult.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019d2709-67df-753f-8c93-c9c1d72a81dd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-67df-753f-8c93-c9c1d72a81dd",
        "storage_key": "property/6767906449165620/019d2709-67df-753f-8c93-c9c1d72a81dd.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.t3fitnesstx.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17367124648149841982&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "t3-fitness",
      "poi_latitude": "31.0818656",
      "poi_longitude": "-97.3805553",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 254-742-2020",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019d2709-8668-77db-bc1e-3fce023a462b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-8668-77db-bc1e-3fce023a462b",
        "storage_key": "property/6767906449165620/019d2709-8668-77db-bc1e-3fce023a462b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJnapPHRFrRYYRPvjmPtprBPE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_481cb87a-0aac-4890-895d-de6343618888",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165620",
      "source": "custom",
      "poi_name": "Ulta Beauty",
      "poi_type": "Health and Wellness",
      "poi_address": "2112 SW H K Dodgen Loop Suite 143A, Temple, TX 76504, USA",
      "poi_short_description": "Clean chain store selling cosmetics, skincare, hair products and tools, along with salon services.",
      "poi_long_description": "Chain with a diverse selection of cosmetics & other beauty products, plus on-site salon services.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019d2709-6b21-708a-8ae6-483f72fd1de8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-6b21-708a-8ae6-483f72fd1de8",
        "storage_key": "property/6767906449165620/019d2709-6b21-708a-8ae6-483f72fd1de8.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "https://www.ulta.com/stores/temple-tx-539",
      "poi_directions_map_url": "https://maps.google.com/?cid=9211260270134082499&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ulta-beauty",
      "poi_latitude": "31.0787814",
      "poi_longitude": "-97.3781617",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 254-771-2079",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019d2709-8668-77db-bc1e-3fce023a462b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-8668-77db-bc1e-3fce023a462b",
        "storage_key": "property/6767906449165620/019d2709-8668-77db-bc1e-3fce023a462b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJDX7MKBRrRYYRw7sCj2n41H8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hair_salon"
    },
    {
      "id": "custom_590cdaaf-e789-4f20-a998-3449d14e6deb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165620",
      "source": "custom",
      "poi_name": "Powerhouse Cheer & Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "907 E 13th Ave, Belton, TX 76513, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019d2709-6b80-7297-b356-9c120c0a0909.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-6b80-7297-b356-9c120c0a0909",
        "storage_key": "property/6767906449165620/019d2709-6b80-7297-b356-9c120c0a0909.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "http://powerhousecheer-fitness.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4077778023594955314&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "powerhouse-cheer--fitness",
      "poi_latitude": "31.0652417",
      "poi_longitude": "-97.4472073",
      "poi_miles_from_property": "6.4",
      "poi_walking_minutes": "2 hours 20 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 254-939-9900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019d2709-8668-77db-bc1e-3fce023a462b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-8668-77db-bc1e-3fce023a462b",
        "storage_key": "property/6767906449165620/019d2709-8668-77db-bc1e-3fce023a462b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJQ5r17RlARYYRMpJF6YEtlzg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "custom_0874ac36-9f52-4d21-856d-bfccaf406305",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165620",
      "source": "custom",
      "poi_name": "Animal Medical Care",
      "poi_type": "Health and Wellness",
      "poi_address": "1604 W Avenue H, Temple, TX 76504, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019d2709-6c43-70fe-a8eb-52a25baa25cb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-6c43-70fe-a8eb-52a25baa25cb",
        "storage_key": "property/6767906449165620/019d2709-6c43-70fe-a8eb-52a25baa25cb.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.amctemple.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16865365717075978202&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "animal-medical-care",
      "poi_latitude": "31.0938496",
      "poi_longitude": "-97.3609404",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 7 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 254-778-5246",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019d2709-8668-77db-bc1e-3fce023a462b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-8668-77db-bc1e-3fce023a462b",
        "storage_key": "property/6767906449165620/019d2709-8668-77db-bc1e-3fce023a462b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJbeclknlrRYYR2mddXcPQDeo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_fb2b9762-b936-4be8-b080-92e84a978b2a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165620",
      "source": "custom",
      "poi_name": "Animal Emergency Center of Temple- Belton",
      "poi_type": "Health and Wellness",
      "poi_address": "3809 S General Bruce Dr #108, Temple, TX 76502, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019d2709-6cb6-76cf-9f4f-f2f2b77cf552.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-6cb6-76cf-9f4f-f2f2b77cf552",
        "storage_key": "property/6767906449165620/019d2709-6cb6-76cf-9f4f-f2f2b77cf552.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.animalemergencytemple.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17888373475908244491&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "animal-emergency-center-of-temple--belton",
      "poi_latitude": "31.0882967",
      "poi_longitude": "-97.3881946",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 9 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 254-231-3774",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019d2709-8668-77db-bc1e-3fce023a462b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-8668-77db-bc1e-3fce023a462b",
        "storage_key": "property/6767906449165620/019d2709-8668-77db-bc1e-3fce023a462b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJPSQ3XARrRYYRC9QHUeZEQPg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_0f9aefb4-734d-4ce8-b6e2-38162f39f26f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165620",
      "source": "custom",
      "poi_name": "Extreme Cheer & Tumble",
      "poi_type": "Health and Wellness",
      "poi_address": "20 Old Waco Rd, Temple, TX 76502, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019d2709-6fea-77fb-ac0a-7a11e9eeeef6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-6fea-77fb-ac0a-7a11e9eeeef6",
        "storage_key": "property/6767906449165620/019d2709-6fea-77fb-ac0a-7a11e9eeeef6.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://extremecheer-tumble.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9486385268268869438&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "extreme-cheer--tumble",
      "poi_latitude": "31.1164173",
      "poi_longitude": "-97.4174833",
      "poi_miles_from_property": "6.3",
      "poi_walking_minutes": "2 hours 19 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 254-780-0087",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019d2709-8234-712b-8188-c9cee6569b8e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-8234-712b-8188-c9cee6569b8e",
        "storage_key": "property/6767906449165620/019d2709-8234-712b-8188-c9cee6569b8e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJy_tfAkBqRYYRPieq9SNppoM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_b0ec18d4-ced8-4c38-801f-8b6a92db0717",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165620",
      "source": "custom",
      "poi_name": "Dapper & Dashin' Salon & Shop - Temple, TX",
      "poi_type": "Health and Wellness",
      "poi_address": "3010 Scott Blvd # 102, Temple, TX 76504, USA",
      "poi_short_description": "Charming salon featuring haircuts, coloring and beard care for men and children.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019d2709-6fe3-726e-9f22-68987af3f656.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-6fe3-726e-9f22-68987af3f656",
        "storage_key": "property/6767906449165620/019d2709-6fe3-726e-9f22-68987af3f656.webp",
        "width": 851,
        "height": 315
      },
      "poi_business_url": "https://dapperanddashin.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15708560085228193133&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "dapper--dashin-salon--shop---temple-tx",
      "poi_latitude": "31.08434129999999",
      "poi_longitude": "-97.3804559",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 254-295-0600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019d2709-8668-77db-bc1e-3fce023a462b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-8668-77db-bc1e-3fce023a462b",
        "storage_key": "property/6767906449165620/019d2709-8668-77db-bc1e-3fce023a462b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJH9jSGFJrRYYRbQXohCsEANo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hair_salon"
    },
    {
      "id": "custom_413582c0-0029-41a5-9c54-0146c5d853de",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165620",
      "source": "custom",
      "poi_name": "Baylor Scott & White Medical Center - Temple",
      "poi_type": "Health and Wellness",
      "poi_address": "2401 S 31st St, Temple, TX 76508, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019d2709-709a-7557-aba7-88408c91c50e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-709a-7557-aba7-88408c91c50e",
        "storage_key": "property/6767906449165620/019d2709-709a-7557-aba7-88408c91c50e.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "https://www.bswhealth.com/locations/hospital/temple?utm_source=pg-google&utm_medium=organic&utm_campaign=pg-listings",
      "poi_directions_map_url": "https://maps.google.com/?cid=17611811835745246270&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "baylor-scott--white-medical-center---temple",
      "poi_latitude": "31.0792544",
      "poi_longitude": "-97.3623929",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 254-724-2111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019d2709-867b-70b7-aa0c-6661aee177d9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-867b-70b7-aa0c-6661aee177d9",
        "storage_key": "property/6767906449165620/019d2709-867b-70b7-aa0c-6661aee177d9.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJUcqln2hrRYYRPpydoI25afQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_30852200-1a4f-4c7d-bdb1-ebbc718051bb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165620",
      "source": "custom",
      "poi_name": "V.A. HOSPITAL",
      "poi_type": "Health and Wellness",
      "poi_address": "1901 Veterans Memorial Dr, Temple, TX 76504, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019d2709-71db-77ec-9eb7-d6731363dfa0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-71db-77ec-9eb7-d6731363dfa0",
        "storage_key": "property/6767906449165620/019d2709-71db-77ec-9eb7-d6731363dfa0.webp",
        "width": 1280,
        "height": 577
      },
      "poi_business_url": "https://www.va.gov/directory/guide/state_SUD.cfm?STATE=TX",
      "poi_directions_map_url": "https://maps.google.com/?cid=11450523901184041120&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "va-hospital",
      "poi_latitude": "31.0763373",
      "poi_longitude": "-97.3471981",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 800-423-2111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019d2709-864a-7330-81fc-2d9d3c6068e0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-864a-7330-81fc-2d9d3c6068e0",
        "storage_key": "property/6767906449165620/019d2709-864a-7330-81fc-2d9d3c6068e0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJqW-cN1ttRYYRoOAxFtJu6J4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_80fd77f0-1c87-4e0c-a98e-1ac808faed6f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165620",
      "source": "custom",
      "poi_name": "Crossroads Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "6600 Research Lp, Temple, TX 76502, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019d2709-74a8-70e9-a4c5-ba0f8b3a5732.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-74a8-70e9-a4c5-ba0f8b3a5732",
        "storage_key": "property/6767906449165620/019d2709-74a8-70e9-a4c5-ba0f8b3a5732.webp",
        "width": 576,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=12717652189665530495&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "crossroads-park",
      "poi_latitude": "31.1244897",
      "poi_longitude": "-97.4088685",
      "poi_miles_from_property": "6.3",
      "poi_walking_minutes": "2 hours 20 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019d2709-8a23-76f9-95e1-b17ba5db0eca.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-8a23-76f9-95e1-b17ba5db0eca",
        "storage_key": "property/6767906449165620/019d2709-8a23-76f9-95e1-b17ba5db0eca.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJd97G4fprRYYRf5L7FUktfrA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_3a047027-8f4c-4dc9-912a-a709f1d4faee",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165620",
      "source": "custom",
      "poi_name": "Lions Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "4320 Lions Park Dr, Temple, TX 76502, USA",
      "poi_short_description": "Large, pretty park featuring playgrounds, dog parks, ball fields, disc golf and trails.",
      "poi_long_description": "People say this city park offers a dog park, playgrounds, walking trails, and sports fields. They highlight the fenced-in playground, the well-maintained dog park, and the variety of activities available. They also like the covered tables and the disc golf course. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019d2709-7614-7338-a64a-4ddfdc67eade.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-7614-7338-a64a-4ddfdc67eade",
        "storage_key": "property/6767906449165620/019d2709-7614-7338-a64a-4ddfdc67eade.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://templeparks.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13010341925667772784&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "lions-park",
      "poi_latitude": "31.0639893",
      "poi_longitude": "-97.40266760000002",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 6 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 254-298-5690",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019d2709-8a23-76f9-95e1-b17ba5db0eca.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-8a23-76f9-95e1-b17ba5db0eca",
        "storage_key": "property/6767906449165620/019d2709-8a23-76f9-95e1-b17ba5db0eca.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJlVSchtpqRYYRcJnMtQwFjrQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_de0d380d-14a1-40f0-a125-99b4d8706b76",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165620",
      "source": "custom",
      "poi_name": "Sammons Golf Course",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2727 W Adams Ave, Temple, TX 76504, USA",
      "poi_short_description": "Public golf course offering fishing and a pool.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019d2709-7518-7165-b74a-5be5da83e0ca.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-7518-7165-b74a-5be5da83e0ca",
        "storage_key": "property/6767906449165620/019d2709-7518-7165-b74a-5be5da83e0ca.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://golfsammons.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4080503160825863788&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sammons-golf-course",
      "poi_latitude": "31.1041612",
      "poi_longitude": "-97.3696681",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 43 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 254-771-2030",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019d2709-8a1b-72e8-bce3-e70065c42823.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-8a1b-72e8-bce3-e70065c42823",
        "storage_key": "property/6767906449165620/019d2709-8a1b-72e8-bce3-e70065c42823.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJg0Kx2phrRYYRbF7iXQHcoDg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_bf9f0b07-5eb1-48f7-94f0-5e0532bfa162",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165620",
      "source": "custom",
      "poi_name": "Heritage Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1502 Park Ave, Belton, TX 76513, USA",
      "poi_short_description": "Well-maintained outdoor space with baseball fields, playgrounds, soccer fields and a river for swimming.",
      "poi_long_description": "People say this park offers a dog park with separate enclosures for small and large dogs, a playground, and a fishing pond. They highlight the park is clean, well-maintained, and peaceful, with shady trails suitable for walking or running. They also like the family-friendly atmosphere and the presence of a doggy fountain. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019d2709-7798-72e5-b7d8-46d283807c54.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-7798-72e5-b7d8-46d283807c54",
        "storage_key": "property/6767906449165620/019d2709-7798-72e5-b7d8-46d283807c54.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.beltontexas.gov/departments/parks_and_recreation/parks.php",
      "poi_directions_map_url": "https://maps.google.com/?cid=3952942952325045927&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "heritage-park",
      "poi_latitude": "31.0669943",
      "poi_longitude": "-97.4441223",
      "poi_miles_from_property": "6.2",
      "poi_walking_minutes": "2 hours 16 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 254-933-5860",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019d2709-8a23-76f9-95e1-b17ba5db0eca.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-8a23-76f9-95e1-b17ba5db0eca",
        "storage_key": "property/6767906449165620/019d2709-8a23-76f9-95e1-b17ba5db0eca.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJic3gxxhARYYRp9636qus2zY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_a70a0ba6-0416-4059-8f31-0ac8de726e0c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165620",
      "source": "custom",
      "poi_name": "Jaycee Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Jaycee Park, 2302 W Avenue Z, Temple, TX 76504, USA",
      "poi_short_description": "Space-themed option offering a splash pad, a playground and a rocket ship, plus swings and picnic tables.",
      "poi_long_description": "Visitors say this city park has a splash pad that's clean and well-maintained, as well as playgrounds, wildflowers, musical instruments, and workout equipment. They like that it's a great place for kids of all ages to have fun, and many mention it's a popular spot for birthday parties.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019d2709-79d7-7219-8275-ce49c0f0dab6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-79d7-7219-8275-ce49c0f0dab6",
        "storage_key": "property/6767906449165620/019d2709-79d7-7219-8275-ce49c0f0dab6.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.templeparks.com/business_detail_T15_R36.php",
      "poi_directions_map_url": "https://maps.google.com/?cid=2180698803467665368&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "jaycee-park",
      "poi_latitude": "31.0793391",
      "poi_longitude": "-97.3739267",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 254-298-5690",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019d2709-8a23-76f9-95e1-b17ba5db0eca.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-8a23-76f9-95e1-b17ba5db0eca",
        "storage_key": "property/6767906449165620/019d2709-8a23-76f9-95e1-b17ba5db0eca.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJDap3SmtrRYYR2D_PBgJmQx4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_f2281c79-a1fb-4c8f-80c5-d7ac07846d42",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165620",
      "source": "custom",
      "poi_name": "Temple Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "315 W Avenue B, Temple, TX 76501, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019d2709-79cb-711c-a9f7-7c51304f2f6e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-79cb-711c-a9f7-7c51304f2f6e",
        "storage_key": "property/6767906449165620/019d2709-79cb-711c-a9f7-7c51304f2f6e.webp",
        "width": 1280,
        "height": 844
      },
      "poi_business_url": "https://www.amtrak.com/servlet/ContentServer?pagename=am/am2Station/Station_Page&code=TPL",
      "poi_directions_map_url": "https://maps.google.com/?cid=17478799269227792206&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "temple-station",
      "poi_latitude": "31.0957286",
      "poi_longitude": "-97.3452969",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 800-872-7245",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019d2709-8a66-713a-9bc2-c3fc580d43e5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-8a66-713a-9bc2-c3fc580d43e5",
        "storage_key": "property/6767906449165620/019d2709-8a66-713a-9bc2-c3fc580d43e5.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJi85f3YZsRYYRTgeuJlQrkfI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "custom_96a811d1-0aa8-4aaf-a678-d68796256bf8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165620",
      "source": "custom",
      "poi_name": "McLane",
      "poi_type": "Major Employers & Offices",
      "poi_address": "4747 McLane Pkwy, Temple, TX 76504, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019d2709-7b50-718b-96df-c1691326cc41.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-7b50-718b-96df-c1691326cc41",
        "storage_key": "property/6767906449165620/019d2709-7b50-718b-96df-c1691326cc41.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.mclaneco.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4531488113058822699&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mclane",
      "poi_latitude": "31.1459307",
      "poi_longitude": "-97.3795999",
      "poi_miles_from_property": "8.5",
      "poi_walking_minutes": "3 hours 11 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 254-771-7500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019d2709-8668-77db-bc1e-3fce023a462b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-8668-77db-bc1e-3fce023a462b",
        "storage_key": "property/6767906449165620/019d2709-8668-77db-bc1e-3fce023a462b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ21BJTGFpRYYRK7rGEm4U4z4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_4acfd952-16c5-445d-935d-039a76769d02",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165620",
      "source": "custom",
      "poi_name": "Palladio Industries Inc.",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2114 Trino Rd, Temple, TX 76504, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019d2709-7c51-71ec-82bc-c8ef7db181e7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-7c51-71ec-82bc-c8ef7db181e7",
        "storage_key": "property/6767906449165620/019d2709-7c51-71ec-82bc-c8ef7db181e7.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.palladioinc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1131993305101729290&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "palladio-industries-inc",
      "poi_latitude": "31.1463727",
      "poi_longitude": "-97.3474783",
      "poi_miles_from_property": "7",
      "poi_walking_minutes": "2 hours 39 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 254-598-7017",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019d2709-8668-77db-bc1e-3fce023a462b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-8668-77db-bc1e-3fce023a462b",
        "storage_key": "property/6767906449165620/019d2709-8668-77db-bc1e-3fce023a462b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJPW4STixvRYYRCn611umltQ8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_5e40c61d-729f-449d-941b-344bc43b3be2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165620",
      "source": "custom",
      "poi_name": "Bell County Community Supervision",
      "poi_type": "Major Employers & Offices",
      "poi_address": "200 W Avenue G, Temple, TX 76504, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.bellcountytx.com/departments/cscd(adult_probation)/index.php",
      "poi_directions_map_url": "https://maps.google.com/?cid=5645812315341425362&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "bell-county-community-supervision",
      "poi_latitude": "31.0907141",
      "poi_longitude": "-97.3462274",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 254-770-6800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019d2709-8668-77db-bc1e-3fce023a462b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-8668-77db-bc1e-3fce023a462b",
        "storage_key": "property/6767906449165620/019d2709-8668-77db-bc1e-3fce023a462b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJCcMqhIRsRYYR0opzVGP0WU4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_c53ab8a3-b20f-4145-89f6-42e7a0ec9a21",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165620",
      "source": "custom",
      "poi_name": "Cps Office",
      "poi_type": "Major Employers & Offices",
      "poi_address": "Unnamed Road, Temple, TX 76502, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.dfps.texas.gov/Contact_Us/locations.asp?r=7",
      "poi_directions_map_url": "https://maps.google.com/?cid=16408319772451177584&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "cps-office",
      "poi_latitude": "31.086034",
      "poi_longitude": "-97.3971036",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 254-770-2660",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019d2709-8668-77db-bc1e-3fce023a462b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-8668-77db-bc1e-3fce023a462b",
        "storage_key": "property/6767906449165620/019d2709-8668-77db-bc1e-3fce023a462b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ731MIv1qRYYRcIT45eUPtuM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_69a2a766-9b0c-4774-9c16-7f1b05019973",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165620",
      "source": "custom",
      "poi_name": "Indeco Sales - Belton Headquarters",
      "poi_type": "Major Employers & Offices",
      "poi_address": "805 E 4th Ave, Belton, TX 76513, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019d2709-7dec-7319-9cf0-018bc3445561.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-7dec-7319-9cf0-018bc3445561",
        "storage_key": "property/6767906449165620/019d2709-7dec-7319-9cf0-018bc3445561.webp",
        "width": 750,
        "height": 574
      },
      "poi_business_url": "https://indecosales.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8115554615762194618&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "indeco-sales---belton-headquarters",
      "poi_latitude": "31.0573213",
      "poi_longitude": "-97.454209",
      "poi_miles_from_property": "7.1",
      "poi_walking_minutes": "2 hours 34 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 800-692-4256",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019d2709-8668-77db-bc1e-3fce023a462b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-8668-77db-bc1e-3fce023a462b",
        "storage_key": "property/6767906449165620/019d2709-8668-77db-bc1e-3fce023a462b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJifBDEA5ARYYRupDJy-w9oHA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_6269af2d-41da-4f3a-8622-2e8829276afc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165620",
      "source": "custom",
      "poi_name": "Thornton Elementary School",
      "poi_type": "Education",
      "poi_address": "2825 Cottonwood Ln, Temple, TX 76502, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019d7912-c800-709c-b784-0a3378e4bbf5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-c800-709c-b784-0a3378e4bbf5",
        "storage_key": "property/6767906449165620/019d7912-c800-709c-b784-0a3378e4bbf5.webp",
        "width": 1280,
        "height": 636
      },
      "poi_business_url": "http://thornton.tisd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14386194369873724398&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "thornton-elementary-school",
      "poi_latitude": "31.0733838",
      "poi_longitude": "-97.382314",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 254-215-5700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019cfb45-de2e-710f-9e5b-3a28909f4aa5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb45-de2e-710f-9e5b-3a28909f4aa5",
        "storage_key": "property/6767906449165620/019cfb45-de2e-710f-9e5b-3a28909f4aa5.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ98w5Qz1rRYYR7kMM3o4Hpsc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_7fcc5665-6f1c-40dd-8ad5-c8b5fe9fb3a6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165620",
      "source": "custom",
      "poi_name": "Raye-Allen Elementary School",
      "poi_type": "Education",
      "poi_address": "5015 S 5th St, Temple, TX 76502, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019d7912-c8be-722c-a8d1-321ef5f54c9a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-c8be-722c-a8d1-321ef5f54c9a",
        "storage_key": "property/6767906449165620/019d7912-c8be-722c-a8d1-321ef5f54c9a.webp",
        "width": 1280,
        "height": 511
      },
      "poi_business_url": "http://www.tisd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10586344686248917730&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "raye-allen-elementary-school",
      "poi_latitude": "31.0475788",
      "poi_longitude": "-97.3602523",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 254-215-5800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019cfb45-de2e-710f-9e5b-3a28909f4aa5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb45-de2e-710f-9e5b-3a28909f4aa5",
        "storage_key": "property/6767906449165620/019cfb45-de2e-710f-9e5b-3a28909f4aa5.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJMWrYeq0URYYR4vq1PWdA6pI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_f1be395b-da91-4150-8aa6-94f2caff39b8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165620",
      "source": "custom",
      "poi_name": "Travis Middle School",
      "poi_type": "Education",
      "poi_address": "1500 S 19th St, Temple, TX 76504, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.tisd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4911235990871173233&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "travis-middle-school",
      "poi_latitude": "31.08425309999999",
      "poi_longitude": "-97.3572969",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 254-215-6300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019cfb45-de2e-710f-9e5b-3a28909f4aa5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb45-de2e-710f-9e5b-3a28909f4aa5",
        "storage_key": "property/6767906449165620/019cfb45-de2e-710f-9e5b-3a28909f4aa5.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ6Q_Nh2RrRYYRcWj94xw3KEQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_cf6fa0de-8137-46bc-8969-7c039442b1e4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165620",
      "source": "custom",
      "poi_name": "Bonham Middle School",
      "poi_type": "Education",
      "poi_address": "4600 Midway Dr, Temple, TX 76502, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019d7912-c967-756e-81a3-2e95128d053a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-c967-756e-81a3-2e95128d053a",
        "storage_key": "property/6767906449165620/019d7912-c967-756e-81a3-2e95128d053a.webp",
        "width": 1280,
        "height": 462
      },
      "poi_business_url": "http://www.tisd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5884817839403397881&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "bonham-middle-school",
      "poi_latitude": "31.0784716",
      "poi_longitude": "-97.4026659",
      "poi_miles_from_property": "3.2 mi",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 254-215-6600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019cfb45-de2e-710f-9e5b-3a28909f4aa5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb45-de2e-710f-9e5b-3a28909f4aa5",
        "storage_key": "property/6767906449165620/019cfb45-de2e-710f-9e5b-3a28909f4aa5.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJAdS37-ZqRYYR-XKFVaUSq1E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_cd2e86fd-cf84-43ee-ac39-36e651b4ea6a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165620",
      "source": "custom",
      "poi_name": "Temple High School",
      "poi_type": "Education",
      "poi_address": "415 N 31st St, Temple, TX 76504, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019d7912-c71a-72ae-ad16-cd71dfa43aa2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-c71a-72ae-ad16-cd71dfa43aa2",
        "storage_key": "property/6767906449165620/019d7912-c71a-72ae-ad16-cd71dfa43aa2.webp",
        "width": 1280,
        "height": 850
      },
      "poi_business_url": "http://ths.tisd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7515229877724520505&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "temple-high-school",
      "poi_latitude": "31.1062637",
      "poi_longitude": "-97.3535861",
      "poi_miles_from_property": "3.8 mi",
      "poi_walking_minutes": "1 hour 27 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 254-215-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019cfb45-de2e-710f-9e5b-3a28909f4aa5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb45-de2e-710f-9e5b-3a28909f4aa5",
        "storage_key": "property/6767906449165620/019cfb45-de2e-710f-9e5b-3a28909f4aa5.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJaQdpMYdrRYYROSAso8F1S2g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_32f52648-7d2b-4983-b9a4-fb09f5d65d42",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165620",
      "source": "custom",
      "poi_name": "Saigon Cafe",
      "poi_type": "Restaurants",
      "poi_address": "220 SW H K Dodgen Loop, Temple, TX 76504, USA",
      "poi_short_description": "Understated outfit offering a variety of Vietnamese, Malaysian & Chinese classics, plus beer & wine.",
      "poi_long_description": "People say this Asian restaurant serves delicious sweet and sour pork, orange chicken, and beef in garlic sauce. They also highlight the generous portions, affordable prices, and friendly, attentive service.\n\nOther reviews mention the food can be bland.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019d7912-d50d-7258-a11d-74f7f2b2e13f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-d50d-7258-a11d-74f7f2b2e13f",
        "storage_key": "property/6767906449165620/019d7912-d50d-7258-a11d-74f7f2b2e13f.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.saigoncafetx.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2793212754949586720&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "saigon-cafe",
      "poi_latitude": "31.0712409",
      "poi_longitude": "-97.3569614",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 254-773-4263",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019cfb45-de32-735b-b6d8-b8bb8bce7397.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb45-de32-735b-b6d8-b8bb8bce7397",
        "storage_key": "property/6767906449165620/019cfb45-de32-735b-b6d8-b8bb8bce7397.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJKcdxoF5rRYYRID_cmDN8wyY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "asian_restaurant"
    },
    {
      "id": "custom_a73eb859-e0e3-46da-9203-2325ab453403",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165620",
      "source": "custom",
      "poi_name": "Sonic Drive-In",
      "poi_type": "Restaurants",
      "poi_address": "1401 Marlandwood Rd, Temple, TX 76502, USA",
      "poi_short_description": "Fast-food burger & fries joint with an old-school feel, including retro drive-in service.",
      "poi_long_description": "People say this fast food restaurant offers great drinks and corn dogs.\n\nOther reviews mention the service can be slow and orders can be incorrect.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019d7912-db63-758b-be56-daffb99574d6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-db63-758b-be56-daffb99574d6",
        "storage_key": "property/6767906449165620/019d7912-db63-758b-be56-daffb99574d6.webp",
        "width": 1200,
        "height": 800
      },
      "poi_business_url": "http://www.sonicdrivein.com/locations/us/tx/temple/1401-marlandwood-road/store-4495?utm_source=google-my-business&utm_medium=organic&utm_campaign=website-link&y_source=1_MjAzMzg1MTY5Mi03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=3185431297886209785&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "sonic-drive-in",
      "poi_latitude": "31.0626149",
      "poi_longitude": "-97.3673876",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 254-742-1777",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019cfb45-de32-735b-b6d8-b8bb8bce7397.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb45-de32-735b-b6d8-b8bb8bce7397",
        "storage_key": "property/6767906449165620/019cfb45-de32-735b-b6d8-b8bb8bce7397.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ997ZTk9rRYYR-UbrZuPsNCw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_e82e4a2b-7820-42ba-8e20-61115b58c8bf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165620",
      "source": "custom",
      "poi_name": "Sam's Southern Eatery",
      "poi_type": "Restaurants",
      "poi_address": "221 SW H K Dodgen Loop, Temple, TX 76502, USA",
      "poi_short_description": "Southern-style po' boys, burgers & fried fish come in generous portions at this casual chain eatery.",
      "poi_long_description": "People say this restaurant serves great fried fish, shrimp, and red beans and rice. They also highlight the affordable prices, generous portions, and friendly staff.\n\nOther reviews mention the atmosphere can be hot.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019d7912-d4f7-77d3-abb6-e5fccdf51f17.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-d4f7-77d3-abb6-e5fccdf51f17",
        "storage_key": "property/6767906449165620/019d7912-d4f7-77d3-abb6-e5fccdf51f17.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.samssoutherneatery.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2141627283262184103&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "sam-s-southern-eatery",
      "poi_latitude": "31.07002129999999",
      "poi_longitude": "-97.3579438",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 254-231-3840",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019cfb45-de32-735b-b6d8-b8bb8bce7397.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb45-de32-735b-b6d8-b8bb8bce7397",
        "storage_key": "property/6767906449165620/019cfb45-de32-735b-b6d8-b8bb8bce7397.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJf6uTI4FBRYYRp5og1KqWuB0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_bad83972-4387-4b89-aea5-c76a92250bd5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165620",
      "source": "custom",
      "poi_name": "Megg's Cafe",
      "poi_type": "Restaurants",
      "poi_address": "1749 Everton Dr, Temple, TX 76504, USA",
      "poi_short_description": "Relaxed spot for locally sourced breakfast dishes & sandwiches, plus craft brews & cocktails.",
      "poi_long_description": "People say this restaurant serves delicious deviled eggs, chicken and waffles, and cinnamon rolls. They also highlight the attentive service, quick service, and friendly staff.\n\nOther reviews mention the food can be overcooked.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019d7912-dc2d-7414-87ff-0f6bfe3f7d5c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-dc2d-7414-87ff-0f6bfe3f7d5c",
        "storage_key": "property/6767906449165620/019d7912-dc2d-7414-87ff-0f6bfe3f7d5c.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.meggs-cafe.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2243058954605394080&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "megg-s-cafe",
      "poi_latitude": "31.075544",
      "poi_longitude": "-97.368833",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 254-771-3800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019cfb45-de32-735b-b6d8-b8bb8bce7397.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb45-de32-735b-b6d8-b8bb8bce7397",
        "storage_key": "property/6767906449165620/019cfb45-de32-735b-b6d8-b8bb8bce7397.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJP5nX9GprRYYRoHiDJzzyIB8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_b36b3c9c-0c53-4355-93ea-efdcfb96da67",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165620",
      "source": "custom",
      "poi_name": "Bill's Grill",
      "poi_type": "Restaurants",
      "poi_address": "1906 S 1st St, Temple, TX 76504, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019d7912-e350-753e-8271-bb54d6334d4f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-e350-753e-8271-bb54d6334d4f",
        "storage_key": "property/6767906449165620/019d7912-e350-753e-8271-bb54d6334d4f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://m.facebook.com/pages/Bills-Grill/108100812565650",
      "poi_directions_map_url": "https://maps.google.com/?cid=3569539232518804890&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "bill-s-grill",
      "poi_latitude": "31.0778358",
      "poi_longitude": "-97.3496454",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 254-773-3030",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019cfb45-de32-735b-b6d8-b8bb8bce7397.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb45-de32-735b-b6d8-b8bb8bce7397",
        "storage_key": "property/6767906449165620/019cfb45-de32-735b-b6d8-b8bb8bce7397.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJNefiop9sRYYRmpUaDgWNiTE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_3adbdfb9-3d70-4394-9e23-9d14284560e4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165620",
      "source": "custom",
      "poi_name": "Roopa's Kitchen- Authentic Indian Cuisine",
      "poi_type": "Restaurants",
      "poi_address": "1710 Canyon Creek Dr, Temple, TX 76502, USA",
      "poi_short_description": "Cozy Indian spot serving traditional fare, plus veggie & gluten-free dishes in a minimalist space.",
      "poi_long_description": "People say this Indian restaurant serves delicious butter chicken and chicken tikka. They also highlight the tender meat, flavorful dishes, and good portion sizes.\n\nOther reviews mention the food can be spicy.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019d7912-e532-754c-be51-33fa4e845ae7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-e532-754c-be51-33fa4e845ae7",
        "storage_key": "property/6767906449165620/019d7912-e532-754c-be51-33fa4e845ae7.webp",
        "width": 1280,
        "height": 850
      },
      "poi_business_url": "http://www.roopaskitchen.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=296956214290233021&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "roopa-s-kitchen-authentic-indian-cuisine",
      "poi_latitude": "31.06216199999999",
      "poi_longitude": "-97.3742997",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 254-239-5505",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019cfb45-de32-735b-b6d8-b8bb8bce7397.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb45-de32-735b-b6d8-b8bb8bce7397",
        "storage_key": "property/6767906449165620/019cfb45-de32-735b-b6d8-b8bb8bce7397.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJs1cpPlFrRYYRvTadghoAHwQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "indian_restaurant"
    },
    {
      "id": "custom_09567eff-bc5e-4324-8762-ccc977c1b83f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165620",
      "source": "custom",
      "poi_name": "Academy Sports + Outdoors",
      "poi_type": "Restaurants",
      "poi_address": "1407 Marlandwood Rd, Temple, TX 76502, USA",
      "poi_short_description": "Sporting goods chain selling athletic apparel & footwear, plus outdoor gear & fitness equipment.",
      "poi_long_description": "People say this sporting goods store offers a wide selection of products, including fishing licenses, steel-toe boots, and workout clothes. They also highlight the friendly and helpful service, and the quick checkout process.\n\nSome reviews mention the store can be hot.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019d7912-ef25-7794-bb10-c5352483b8f3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-ef25-7794-bb10-c5352483b8f3",
        "storage_key": "property/6767906449165620/019d7912-ef25-7794-bb10-c5352483b8f3.webp",
        "width": 1137,
        "height": 640
      },
      "poi_business_url": "https://www.academy.com/storelocator/texas/temple/store-0045",
      "poi_directions_map_url": "https://maps.google.com/?cid=661535314250659033&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "academy-sports-outdoors",
      "poi_latitude": "31.0624718",
      "poi_longitude": "-97.3685002",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 254-742-7350",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019cfb45-ddbb-74de-9a63-b522148789cd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb45-ddbb-74de-9a63-b522148789cd",
        "storage_key": "property/6767906449165620/019cfb45-ddbb-74de-9a63-b522148789cd.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJV7n0ukhrRYYR2XRJBN0-Lgk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sporting_goods_store"
    },
    {
      "id": "custom_7c265ad2-6452-4c17-a35d-0c22bc726c1f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165620",
      "source": "custom",
      "poi_name": "Temple Mall",
      "poi_type": "Restaurants",
      "poi_address": "3111 S 31st St, Temple, TX 76502, USA",
      "poi_short_description": "Long-running standby with varied food & shopping options, a kids’ play area & an IMAX theater.",
      "poi_long_description": "People say this shopping center has some nice stores and is good for walking.\n\nOther reviews mention the mall can be dilapidated and many stores can be closed.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019d7912-f997-7605-9360-ae26cb4db399.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-f997-7605-9360-ae26cb4db399",
        "storage_key": "property/6767906449165620/019d7912-f997-7605-9360-ae26cb4db399.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.templemalltx.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17684647460091395254&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "temple-mall",
      "poi_latitude": "31.0707311",
      "poi_longitude": "-97.3661118",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 254-778-8801",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019cfb45-ddbb-74de-9a63-b522148789cd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb45-ddbb-74de-9a63-b522148789cd",
        "storage_key": "property/6767906449165620/019cfb45-ddbb-74de-9a63-b522148789cd.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJrz6u-UNrRYYRtvzC7Cp9bPU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_bb7d35d6-13e5-4f82-b9d2-ef729bed901e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165620",
      "source": "custom",
      "poi_name": "Temple Towne Center",
      "poi_type": "Restaurants",
      "poi_address": "2112 SW H K Dodgen Loop, Temple, TX 76504, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019d7912-fa6f-7429-a3be-24d109eadfe8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-fa6f-7429-a3be-24d109eadfe8",
        "storage_key": "property/6767906449165620/019d7912-fa6f-7429-a3be-24d109eadfe8.webp",
        "width": 1280,
        "height": 591
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=15153787344051731089&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "temple-towne-center",
      "poi_latitude": "31.0788363",
      "poi_longitude": "-97.3781974",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "51 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019cfb45-ddbb-74de-9a63-b522148789cd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb45-ddbb-74de-9a63-b522148789cd",
        "storage_key": "property/6767906449165620/019cfb45-ddbb-74de-9a63-b522148789cd.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJeWSFGBRrRYYRkXoDHE0RTdI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_908d8513-eda6-426e-890f-0e67cb53d87b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165620",
      "source": "custom",
      "poi_name": "Mary Alice Marshall Performing Arts Center",
      "poi_type": "Entertainment",
      "poi_address": "2487-2567 S 5th St, Temple, TX 76504, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019d7912-fc46-7688-a58e-9ddcaedaf2f5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-fc46-7688-a58e-9ddcaedaf2f5",
        "storage_key": "property/6767906449165620/019d7912-fc46-7688-a58e-9ddcaedaf2f5.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=18278910048603666367&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "mary-alice-marshall-performing-arts-center",
      "poi_latitude": "31.0727346",
      "poi_longitude": "-97.352121",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019cfb45-ddb7-754f-a866-2b6bb0d519cd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb45-ddb7-754f-a866-2b6bb0d519cd",
        "storage_key": "property/6767906449165620/019cfb45-ddb7-754f-a866-2b6bb0d519cd.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJp11pc19rRYYRv_dW6Ne7q_0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "custom_38b127e3-f0d4-4d14-b9dd-69630ce7bc66",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165620",
      "source": "custom",
      "poi_name": "Cinemark Temple and XD",
      "poi_type": "Entertainment",
      "poi_address": "4501 S General Bruce Dr, Temple, TX 76502, USA",
      "poi_short_description": "Chain of movie theaters, some with multiple screens, stadium seats & self-service ticketing kiosks.",
      "poi_long_description": "People say this movie theater offers a wide selection of movies, comfortable reclining seats, and fresh popcorn. They highlight the clean theater, convenient food delivery service, and reasonable prices. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019d7912-fe96-74df-9d67-c503ecd066cf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-fe96-74df-9d67-c503ecd066cf",
        "storage_key": "property/6767906449165620/019d7912-fe96-74df-9d67-c503ecd066cf.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.cinemark.com/theatres/tx-temple/cinemark-temple-and-xd?utm_medium=organic&utm_source=gmb&utm_campaign=local_listing_theater&utm_content=GMB_listing&y_source=1_MTc0OTMwNjUtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=16074436419975196519&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "cinemark-temple-and-xd",
      "poi_latitude": "31.0849236",
      "poi_longitude": "-97.3989943",
      "poi_miles_from_property": "3.4 mi",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 254-773-8497",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019d7913-1192-77b7-b15d-0673d137dcb9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d7913-1192-77b7-b15d-0673d137dcb9",
        "storage_key": "property/6767906449165620/019d7913-1192-77b7-b15d-0673d137dcb9.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJEQYJ6MtyRYYRZy85CcLeE98",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_0b426b79-6638-4c2c-8b6f-6119b68564aa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165620",
      "source": "custom",
      "poi_name": "Lake Polk",
      "poi_type": "Entertainment",
      "poi_address": "Lake Polk, Temple, TX 76504, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=12909927146678798444&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "lake-polk",
      "poi_latitude": "31.1009375",
      "poi_longitude": "-97.3709016",
      "poi_miles_from_property": "3.8 mi",
      "poi_walking_minutes": "1 hour 26 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019cfb45-ddb7-754f-a866-2b6bb0d519cd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb45-ddb7-754f-a866-2b6bb0d519cd",
        "storage_key": "property/6767906449165620/019cfb45-ddb7-754f-a866-2b6bb0d519cd.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJL5TP_p5rRYYRbEj2FVdGKbM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "lake"
    },
    {
      "id": "custom_f70b776a-d7d7-429b-9d6b-7d9a53054778",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165620",
      "source": "custom",
      "poi_name": "James Wilson Park",
      "poi_type": "Entertainment",
      "poi_address": "1909 Curtis B Elliot Dr, Temple, TX 76501, USA",
      "poi_short_description": "Park with a baseball field and a basketball court, plus slides and swings for kids.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019d7913-04c1-7621-b384-a24775c9e823.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-04c1-7621-b384-a24775c9e823",
        "storage_key": "property/6767906449165620/019d7913-04c1-7621-b384-a24775c9e823.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.templeparks.com/facilities___rentals/wilson_park_rec_center.php",
      "poi_directions_map_url": "https://maps.google.com/?cid=17553658240322367667&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "james-wilson-park",
      "poi_latitude": "31.0880967",
      "poi_longitude": "-97.3218957",
      "poi_miles_from_property": "4.0 mi",
      "poi_walking_minutes": "1 hour 30 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 254-298-5690",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019cfb45-dee0-75a8-93bf-1721570081b0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb45-dee0-75a8-93bf-1721570081b0",
        "storage_key": "property/6767906449165620/019cfb45-dee0-75a8-93bf-1721570081b0.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJQQgHsO9sRYYRs_AFkyofm_M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_8b7b62ed-445e-43ad-995f-c9245dacdb09",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165620",
      "source": "custom",
      "poi_name": "Market Place Shopping Center",
      "poi_type": "Restaurants",
      "poi_address": "false",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "false",
      "poi_item_slug": "market-place-shopping-center",
      "poi_latitude": "false",
      "poi_longitude": "false",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "false",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    }
  ],
  "office_hours": [
    {
      "id": "ec_be0166159f57b8f1b80515ed",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165620",
      "day": "TUE",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_c741361e617a14b6e253737d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165620",
      "day": "WED",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_33289358f7b0e63c10d6f26a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165620",
      "day": "THU",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_e1317c20c160e6b8984d8d25",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165620",
      "day": "FRI",
      "open_time": "08:30",
      "close_time": "17:00"
    },
    {
      "id": "ec_9abdb724f7ab880b4b9f83f3",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165620",
      "day": "MON",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_efc31997ac30e8252e1d61e3",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165620",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "15:00"
    },
    {
      "id": "ec_17de323d4f5f53e2e3dbc2d6",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165620",
      "day": "SUN",
      "open_time": "13:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_02e930d5-7d5e-4bde-bde4-78b45340bf1c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165620",
      "rating": "5.0",
      "name": "Leena Serrano",
      "text": "Absolutely in love with my apartment. The office staff is so friendly and welcoming. I was kept up to date with my application process the whole time. Its a quiet neighborhood and for the area prices are more then reasonable, i’m glad i came across the Portico apartments. I just moved in a day ago and i can already tell i’m gonna love it here. There is also always parking and i love how friendly the community itself is as well. I would definitely recommend it to anyone looking for up to date apartments in a quiet neighborhood with amazing staff.",
      "date": "2025-08-03",
      "title": ""
    },
    {
      "id": "custom_4e7ab1c1-93de-4e0f-b243-f7b494f55f17",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165620",
      "rating": "5.0",
      "name": "Ben Lopez",
      "text": "Renewal made easy!!  This past year has been exceptional here at Portico. After an exhaustive search for a new home, I chose Portico in large part because of the management team because of their professionalism and tenure. That stability was important to me. I also love the trees, courtyard/pool, and professional landscaping. It’s evident Alex and her team take pride in ensuring that the property is well maintained and offer many opportunities for residents to connect. It was an easy decision to renew my lease.",
      "date": "2025-10-06",
      "title": ""
    },
    {
      "id": "custom_b7884767-25eb-4ac7-8bed-f72ea4d1ca69",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165620",
      "rating": "5.0",
      "name": "Dawn Smith",
      "text": "This is a great apartment community. Everyone is very nice and respectful. I chose a 1 bedroom apartment and it is perfect. Plenty of storage space and a great pantry. I have been renting for over 40 years all over the world and I recommend Portico at Friars Creek. You get your moneys worth and then some!",
      "date": "2025-05-24",
      "title": ""
    },
    {
      "id": "custom_2d67ac37-ab1f-43b9-8373-d560ac085b7a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165620",
      "rating": "5.0",
      "name": "Jenny Clay",
      "text": "We absolutely love it here.  The staff is amazing and very attentive.  The community of people are so nice. The apt hosts events and pays attention to details. Our dog loves it here,  too! The apartments are spacious and quiet.  Because of the quality of people living here and the police presence, I always feel safe. Would recommend!!",
      "date": "2024-12-25",
      "title": ""
    },
    {
      "id": "custom_5ff52f8b-140d-40c9-acee-f49cf33f698b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165620",
      "rating": "5.0",
      "name": "ibrahim malak",
      "text": "I think that Portico at Friars Creek is one of the nicest places in Temple, TX for renting. The staff at the leasing office are professional and helpful. The house keeping is fast and efficient. It is important to choose the right place to call it home.",
      "date": "2025-09-04",
      "title": ""
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_2eb08f5f-1494-45de-845f-186dcd3b3576",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165620",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019cfb46-9059-765b-afce-93504efd0fda.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "360 virtual tour of leasing office reception area with desk and seating",
        "public_id": "019cfb46-9059-765b-afce-93504efd0fda",
        "storage_key": "property/6767906449165620/019cfb46-9059-765b-afce-93504efd0fda.webp",
        "width": 400,
        "height": 200
      },
      "virtual_tour_title": "Portico at Friars Creek Virtual Tour",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://tour.tourbuilder.com/?tour=5f3658e9dfe02227217b50ae"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019cf79e-7403-73d8-9cdf-294807990196",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "portico-at-friars-creek-apts",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165620"
    },
    {
      "lead_collector_id": "019cf79e-7479-750a-8716-b1ce7e646d3d",
      "lead_source": "LANDING_PAGE",
      "name": "portico-at-friars-creek-apts",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165620"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165620",
      "source": "generator",
      "page_item_url": "apartments-with-pool-temple-tx",
      "search_query": "apartments with pool in Temple TX",
      "category": "Amenity",
      "h1_title": "Apartments with Pool in Temple, TX",
      "h2_subtitle": "Discover premium apartments with pool access in Temple, TX. Elevate your lifestyle at Portico at Friars Creek with our modern amenities.",
      "page_copy": "Nestled in the heart of Temple, TX, Portico at Friars Creek Apartments offers residents the perfect blend of comfort and convenience. Among the many sought-after amenities, our inviting pool stands out, providing an ideal spot for relaxation and socializing. Whether you're looking to take a refreshing dip or soak up the sun on our sundeck, our pool area enhances your living experience.\n\nIn addition to our sparkling pool, Portico at Friars Creek boasts a variety of features designed to elevate your lifestyle. Residents enjoy a state-of-the-art fitness center, beautifully maintained courtyards, and the added peace of mind that comes with a gated community. Our pet-friendly apartments, combined with convenient online services, ensure that both you and your furry friend feel right at home. Explore vibrant living in Temple, TX today and experience life at Portico at Friars Creek.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019cfb45-b14f-7459-845d-ff1f5c8a6d7d.webp",
      "featured_image_media": {
        "alt_text": "Modern living and dining area with a white sofa, glass coffee table, dining table, and armchair.",
        "public_id": "019cfb45-b14f-7459-845d-ff1f5c8a6d7d",
        "storage_key": "property/6767906449165620/019cfb45-b14f-7459-845d-ff1f5c8a6d7d.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Pool in Temple, TX",
      "seo_description": "Find premium apartments with a pool in Temple, TX at Portico at Friars Creek. Experience modern amenities and a vibrant community today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165620",
      "source": "generator",
      "page_item_url": "pet-friendly-apartments-temple-tx",
      "search_query": "pet friendly apartments in Temple Texas",
      "category": "Amenity",
      "h1_title": "Pet Friendly Apartments in Temple, TX",
      "h2_subtitle": "Explore pet friendly apartments in Temple Texas where you and your furry companion can thrive. At Portico at Friars Creek, pets are always welcome!",
      "page_copy": "Portico at Friars Creek in Temple, Texas, understands that pets are part of the family. Our pet friendly apartments offer a welcoming environment for both you and your furry friends. Designed with ample space and thoughtful amenities, our community is the perfect home for pet owners.\n\nResidents of Portico at Friars Creek enjoy the convenience of pet-friendly spaces combined with access to various amenities. Take advantage of the scenic courtyards and wide-ranging community activities that accommodate a fun, active lifestyle. Our gated community also ensures a safe environment for you and your pets. Discover the ideal setting for you and your pets at our vibrant apartments in Temple, TX.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019cfb45-b14f-7459-845d-ff1f5c8a6d7d.webp",
      "featured_image_media": {
        "alt_text": "Modern living and dining area with a white sofa, glass coffee table, dining table, and armchair.",
        "public_id": "019cfb45-b14f-7459-845d-ff1f5c8a6d7d",
        "storage_key": "property/6767906449165620/019cfb45-b14f-7459-845d-ff1f5c8a6d7d.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet Friendly Apartments in Temple, TX",
      "seo_description": "Find your pet friendly apartment in Temple, TX at Portico at Friars Creek. A welcoming community for you and your furry friends!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165620",
      "source": "generator",
      "page_item_url": "luxury-units-in-unit-laundry-temple",
      "search_query": "luxury units with in-unit laundry Temple area",
      "category": "Amenity",
      "h1_title": "Luxury Units with In-Unit Laundry",
      "h2_subtitle": "Discover luxury units with in-unit laundry in the Temple area. Portico at Friars Creek offers top-tier amenities for a comfortable lifestyle.",
      "page_copy": "At Portico at Friars Creek Apartments, located in the vibrant Temple area, luxury living is redefined. Our luxury units come equipped with the essential convenience of in-unit laundry, making your daily routine simpler and more efficient. Say goodbye to laundromat visits and enjoy the ease that comes with having your own washer and dryer right at home.\n\nBeyond in-unit laundry, our luxury units are designed to offer you the ultimate living experience. Residents can indulge in a range of modern amenities, including a fully-equipped fitness center, sparkling pool, and pet-friendly spaces perfect for you and your pets. Whether you’re relaxing on the sundeck or hosting a barbecue at our grilling stations, Portico at Friars Creek provides an exceptional residential experience. Explore luxury living in the Temple area today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019cfb45-b14f-7459-845d-ff1f5c8a6d7d.webp",
      "featured_image_media": {
        "alt_text": "Modern living and dining area with a white sofa, glass coffee table, dining table, and armchair.",
        "public_id": "019cfb45-b14f-7459-845d-ff1f5c8a6d7d",
        "storage_key": "property/6767906449165620/019cfb45-b14f-7459-845d-ff1f5c8a6d7d.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Units with In-Unit Laundry in Temple, TX",
      "seo_description": "Discover luxury living with in-unit laundry in the Temple area at Portico at Friars Creek. Experience top-tier amenities and comfort.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165620",
      "source": "generator",
      "page_item_url": "controlled-access-apartments-near-76502",
      "search_query": "controlled access apartments near 76502",
      "category": "Amenity",
      "h1_title": "Controlled Access Apartments Near 76502",
      "h2_subtitle": "Discover controlled access apartments near 76502 for enhanced security and peace of mind. Experience the safety of Portico at Friars Creek.",
      "page_copy": "Looking for peace of mind in your living environment? Portico at Friars Creek offers controlled access apartments near the 76502 area in Temple, TX. Our secure, gated community ensures that residents feel safe and secure at all times, providing you with a worry-free living experience.\n\nIn addition to controlled access, our apartments are equipped with an array of upscale amenities designed to enhance your lifestyle. From the inviting pool and state-of-the-art fitness center to the pet-friendly spaces and beautifully landscaped courtyards, Portico at Friars Creek has something for everyone. Experience the perfect combination of comfort, security, and convenience by choosing our community as your next home. Discover the ideal living environment near 76502 today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019cfb45-b14f-7459-845d-ff1f5c8a6d7d.webp",
      "featured_image_media": {
        "alt_text": "Modern living and dining area with a white sofa, glass coffee table, dining table, and armchair.",
        "public_id": "019cfb45-b14f-7459-845d-ff1f5c8a6d7d",
        "storage_key": "property/6767906449165620/019cfb45-b14f-7459-845d-ff1f5c8a6d7d.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Controlled Access Apartments Near 76502",
      "seo_description": "Find secure, controlled access apartments near 76502 at Portico at Friars Creek. Enjoy comfort, safety, and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165620",
      "source": "generator",
      "page_item_url": "apartments-fitness-center-temple",
      "search_query": "apartments with fitness center in Temple",
      "category": "Amenity",
      "h1_title": "Apartments with Fitness Center in Temple",
      "h2_subtitle": "Discover apartments with a fitness center in Temple. Enjoy workouts at Portico at Friars Creek's state-of-the-art facilities.",
      "page_copy": "Elevate your fitness routine at Portico at Friars Creek, where our apartments come with a state-of-the-art fitness center located right in Temple, Texas. Our fully-equipped gym allows you to maintain an active lifestyle without needing to leave the comfort of your community.\n\nIn addition to our modern fitness center, residents can take advantage of a host of other amenities including a sparkling pool, pet-friendly spaces, and scenic courtyards. Whether you’re looking to unwind after a long day or keep up with your fitness goals, Portico at Friars Creek provides the perfect environment. Located in Temple, this community offers more than just a place to live—it supports a vibrant lifestyle.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019cfb45-b14f-7459-845d-ff1f5c8a6d7d.webp",
      "featured_image_media": {
        "alt_text": "Modern living and dining area with a white sofa, glass coffee table, dining table, and armchair.",
        "public_id": "019cfb45-b14f-7459-845d-ff1f5c8a6d7d",
        "storage_key": "property/6767906449165620/019cfb45-b14f-7459-845d-ff1f5c8a6d7d.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Fitness Center in Temple",
      "seo_description": "Find your ideal apartment with a fitness center in Temple at Portico at Friars Creek. Enjoy top facilities and a lively community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165620",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-temple-tx",
      "search_query": "one bedroom apartments temple tx",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Temple, TX",
      "h2_subtitle": "Explore one bedroom apartments in Temple, TX at Portico at Friars Creek. Spacious layouts and modern amenities await you.",
      "page_copy": "Experience the convenience and comfort of one bedroom apartments at Portico at Friars Creek in Temple, TX. Designed with your lifestyle in mind, each apartment offers spacious layouts coupled with modern amenities, ensuring a cozy and functional living environment.\n\nOur one bedroom apartments come with in-unit laundry and are part of a vibrant community that features a fitness center, sparkling pool, and pet-friendly areas. Whether you're enjoying a meal in the dining room or relaxing on the sundeck, you'll find that Portico at Friars Creek provides everything you need to feel at home. Discover the perfect one bedroom apartment in Temple, TX today and embrace the ideal blend of style and convenience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019cfb45-b14f-7459-845d-ff1f5c8a6d7d.webp",
      "featured_image_media": {
        "alt_text": "Modern living and dining area with a white sofa, glass coffee table, dining table, and armchair.",
        "public_id": "019cfb45-b14f-7459-845d-ff1f5c8a6d7d",
        "storage_key": "property/6767906449165620/019cfb45-b14f-7459-845d-ff1f5c8a6d7d.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in Temple, TX",
      "seo_description": "Discover one bedroom apartments in Temple, TX at Portico at Friars Creek. Enjoy spacious living and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165620",
      "source": "generator",
      "page_item_url": "two-bedroom-apartments-near-76502",
      "search_query": "two bedroom apartments near 76502",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments Near 76502",
      "h2_subtitle": "Find spacious two bedroom apartments near 76502 at Portico at Friars Creek. Experience comfort and community living.",
      "page_copy": "Portico at Friars Creek offers expansive two bedroom apartments near the bustling 76502 area in Temple, TX. These thoughtfully designed homes provide ample space and modern amenities, ideal for roomies or small families seeking comfortable living quarters.\n\nSet within a vibrant community, our two bedroom apartments include access to a top-notch fitness center, a relaxing pool, and pet-friendly areas, along with scenic courtyards perfect for leisurely strolls. Located conveniently near local attractions and daily essentials, Portico at Friars Creek ensures an enriching lifestyle experience. Come explore the perfect two bedroom apartments that offer both comfort and convenience close to the 76502 area.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019cfb45-b14f-7459-845d-ff1f5c8a6d7d.webp",
      "featured_image_media": {
        "alt_text": "Modern living and dining area with a white sofa, glass coffee table, dining table, and armchair.",
        "public_id": "019cfb45-b14f-7459-845d-ff1f5c8a6d7d",
        "storage_key": "property/6767906449165620/019cfb45-b14f-7459-845d-ff1f5c8a6d7d.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments Near 76502",
      "seo_description": "Explore two bedroom apartments near 76502 at Portico at Friars Creek. Enjoy spacious living with modern features in a vibrant community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165620",
      "source": "generator",
      "page_item_url": "apartments-near-temple-college-tx",
      "search_query": "apartments near Temple College Temple TX",
      "category": "School",
      "h1_title": "Apartments Near Temple College, TX",
      "h2_subtitle": "Discover the ideal apartments near Temple College, Temple, TX at Portico at Friars Creek. Enjoy convenient living close to campus.",
      "page_copy": "Located just a short drive from Temple College, Portico at Friars Creek offers an ideal home base for students and faculty seeking proximity and comfort. Our spacious one and two-bedroom apartments come equipped with modern amenities to enhance your living experience.\n\nWith features like a fitness center, pool, and pet-friendly areas, you'll find everything you need to balance work, study, and leisure. The vibrant community spirit and welcoming environment make these apartments near Temple College, TX the perfect choice for anyone seeking convenience and an unparalleled lifestyle. Discover how easy it is to thrive both academically and socially at Portico at Friars Creek.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019cfb45-b14f-7459-845d-ff1f5c8a6d7d.webp",
      "featured_image_media": {
        "alt_text": "Modern living and dining area with a white sofa, glass coffee table, dining table, and armchair.",
        "public_id": "019cfb45-b14f-7459-845d-ff1f5c8a6d7d",
        "storage_key": "property/6767906449165620/019cfb45-b14f-7459-845d-ff1f5c8a6d7d.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Temple College, TX",
      "seo_description": "Find the perfect apartments near Temple College, TX at Portico at Friars Creek. Enjoy modern amenities and convenient living close to campus.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165620",
      "source": "generator",
      "page_item_url": "apartments-near-meridith-dunbar-academy",
      "search_query": "apartments close to Meridith-Dunbar Early Childhood Academy",
      "category": "School",
      "h1_title": "Apartments Close to Meridith-Dunbar Academy",
      "h2_subtitle": "Discover apartments close to Meridith-Dunbar Early Childhood Academy at Portico at Friars Creek. Enjoy family-friendly living and modern amenities.",
      "page_copy": "Portico at Friars Creek presents an excellent option for families seeking apartments close to Meridith-Dunbar Early Childhood Academy. Located in Temple, TX, our community offers spacious living options with a range of modern amenities like a sundeck, fitness center, and pet-friendly spaces.\n\nEnjoy a vibrant community atmosphere with convenient access to local schools and family-friendly events. Whether it's a relaxing day by the pool or hosting a gathering using our grill facilities, our community provides a nurturing environment ideal for families with young children. Discover the perfect balance of comfort and convenience at Portico at Friars Creek, located near Meridith-Dunbar Early Childhood Academy.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019cfb45-b14f-7459-845d-ff1f5c8a6d7d.webp",
      "featured_image_media": {
        "alt_text": "Modern living and dining area with a white sofa, glass coffee table, dining table, and armchair.",
        "public_id": "019cfb45-b14f-7459-845d-ff1f5c8a6d7d",
        "storage_key": "property/6767906449165620/019cfb45-b14f-7459-845d-ff1f5c8a6d7d.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Meridith-Dunbar Academy",
      "seo_description": "Explore family-friendly apartments close to Meridith-Dunbar Early Childhood Academy at Portico at Friars Creek. Enjoy modern living in Temple, TX.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165620",
      "source": "generator",
      "page_item_url": "apartments-near-baylor-scott-white-temple",
      "search_query": "apartments near Baylor Scott & White Medical Center Temple",
      "category": "Hospital",
      "h1_title": "Apartments Near Baylor Scott & White Temple",
      "h2_subtitle": "Find comfortable apartments near Baylor Scott & White Medical Center in Temple. Portico at Friars Creek offers convenience and comfort.",
      "page_copy": "For those seeking proximity to Baylor Scott & White Medical Center in Temple, Portico at Friars Creek offers a perfect home base. Our thoughtfully designed one and two-bedroom apartments provide both comfort and convenience for healthcare professionals and patients alike.\n\nLocated just minutes away, our community offers modern amenities including a fitness center, pool, and gated access, ensuring a peaceful and enjoyable living experience. Embrace the convenience of living near top-notch medical facilities while enjoying the lush courtyards and community amenities. Discover the benefits of living near Baylor Scott & White by choosing Portico at Friars Creek.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019cfb45-b14f-7459-845d-ff1f5c8a6d7d.webp",
      "featured_image_media": {
        "alt_text": "Modern living and dining area with a white sofa, glass coffee table, dining table, and armchair.",
        "public_id": "019cfb45-b14f-7459-845d-ff1f5c8a6d7d",
        "storage_key": "property/6767906449165620/019cfb45-b14f-7459-845d-ff1f5c8a6d7d.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Baylor Scott & White Temple",
      "seo_description": "Discover convenient living at Portico at Friars Creek, offering apartments near Baylor Scott & White Medical Center in Temple. Perfect for healthcare professionals.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165620",
      "source": "generator",
      "page_item_url": "apartments-close-to-va-hospital-temple-tx",
      "search_query": "apartments close to V.A. HOSPITAL Temple TX",
      "category": "Hospital",
      "h1_title": "Apartments Close to V.A. Hospital Temple, TX",
      "h2_subtitle": "Discover convenient apartments close to the V.A. Hospital in Temple, TX at Portico at Friars Creek. Seamless living near healthcare services.",
      "page_copy": "At Portico at Friars Creek, find the ideal living space close to the V.A. Hospital in Temple, TX. Our community is perfect for healthcare professionals, veterans, and families needing easy access to healthcare services. With spacious one and two-bedroom layouts, our apartments cater to a variety of needs.\n\nEnjoy community amenities such as a pool, sundeck, and grill area, designed to enhance your lifestyle while living near the V.A. Hospital. Our gated community ensures a safe and peaceful environment, providing you with both convenience and tranquility. Make Portico at Friars Creek your new home near the V.A. Hospital in Temple, Texas.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019cfb45-b14f-7459-845d-ff1f5c8a6d7d.webp",
      "featured_image_media": {
        "alt_text": "Modern living and dining area with a white sofa, glass coffee table, dining table, and armchair.",
        "public_id": "019cfb45-b14f-7459-845d-ff1f5c8a6d7d",
        "storage_key": "property/6767906449165620/019cfb45-b14f-7459-845d-ff1f5c8a6d7d.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to V.A. Hospital Temple, TX",
      "seo_description": "Explore ideal living at Portico at Friars Creek, offering apartments close to the V.A. Hospital in Temple, TX. Perfect for professionals and families.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165620",
      "source": "generator",
      "page_item_url": "apartments-near-crossroads-park-temple-tx",
      "search_query": "apartments near Crossroads Park Temple TX",
      "category": "Park",
      "h1_title": "Apartments Near Crossroads Park, Temple TX",
      "h2_subtitle": "Explore apartments near Crossroads Park in Temple, TX at Portico at Friars Creek. Perfect for nature enthusiasts and active lifestyles.",
      "page_copy": "Located near the beautiful Crossroads Park in Temple, TX, Portico at Friars Creek offers an idyllic setting for those who love outdoor activities and serene park views. Our apartment community features spacious one and two-bedroom options equipped with modern comforts and amenities like a fitness center and pool.\n\nEmbrace an active lifestyle with easy access to Crossroads Park's hiking trails, sports fields, and recreational areas, making Portico at Friars Creek the perfect blend of adventure and relaxation. Enjoy the convenience of living near one of Temple's premier outdoor spaces while indulging in community features such as our sundeck and grill. Discover the benefits of nature-centric living today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019cfb45-b14f-7459-845d-ff1f5c8a6d7d.webp",
      "featured_image_media": {
        "alt_text": "Modern living and dining area with a white sofa, glass coffee table, dining table, and armchair.",
        "public_id": "019cfb45-b14f-7459-845d-ff1f5c8a6d7d",
        "storage_key": "property/6767906449165620/019cfb45-b14f-7459-845d-ff1f5c8a6d7d.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Crossroads Park, Temple TX",
      "seo_description": "Experience nature at Portico at Friars Creek, featuring apartments near Crossroads Park in Temple, TX. Ideal for active and outdoor-loving residents.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165620",
      "source": "generator",
      "page_item_url": "lions-park-nearby-apartment-living-temple-tx",
      "search_query": "Lions Park nearby apartment living Temple Texas",
      "category": "Park",
      "h1_title": "Lions Park Nearby Apartment Living in Temple",
      "h2_subtitle": "Enjoy apartment living near Lions Park in Temple, Texas at Portico at Friars Creek. Perfect for those who love the outdoors and community activities.",
      "page_copy": "Experience the convenience of living near Lions Park in Temple, Texas at Portico at Friars Creek. Our community offers one and two-bedroom apartments designed for those who appreciate both comfort and outdoor adventure. With Lions Park just a short stroll away, residents can easily enjoy the park's beautiful trails, picnic areas, and family-friendly activities.\n\nPortico at Friars Creek provides a range of amenities including a pool, fitness center, and delightful courtyards, fostering a community atmosphere that's perfect for relaxation and socializing. Embrace the serene environment and vibrant community living while enjoying the close proximity to Lions Park; make Portico at Friars Creek your new home today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019cfb45-b14f-7459-845d-ff1f5c8a6d7d.webp",
      "featured_image_media": {
        "alt_text": "Modern living and dining area with a white sofa, glass coffee table, dining table, and armchair.",
        "public_id": "019cfb45-b14f-7459-845d-ff1f5c8a6d7d",
        "storage_key": "property/6767906449165620/019cfb45-b14f-7459-845d-ff1f5c8a6d7d.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Lions Park Nearby Apartment Living in Temple",
      "seo_description": "Discover vibrant living at Portico at Friars Creek, offering apartment living near Lions Park in Temple, Texas. Perfect for outdoor enthusiasts.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165620",
      "source": "generator",
      "page_item_url": "heritage-park-local-apartment-community-temple",
      "search_query": "Heritage Park local apartment community Temple",
      "category": "Park",
      "h1_title": "Heritage Park Local Apartment Community Temple",
      "h2_subtitle": "Experience a local apartment community near Heritage Park in Temple, with Portico at Friars Creek. Perfect for a blend of nature and comfort.",
      "page_copy": "Discover the perfect blend of serene nature and modern living at Portico at Friars Creek, a local apartment community near Heritage Park in Temple. Our one and two-bedroom apartments offer ample space and modern amenities, making them ideal for both singles and families who cherish convenience and tranquility.\n\nSituated close to Heritage Park, residents can take advantage of its lush green areas, walking trails, and recreational facilities. Enjoy a community-centric lifestyle with access to our swimming pool, fitness center, and pet-friendly spaces. Portico at Friars Creek offers the perfect setting for those looking to be near Temple's Heritage Park while enjoying a host of residential comforts.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019cfb45-b14f-7459-845d-ff1f5c8a6d7d.webp",
      "featured_image_media": {
        "alt_text": "Modern living and dining area with a white sofa, glass coffee table, dining table, and armchair.",
        "public_id": "019cfb45-b14f-7459-845d-ff1f5c8a6d7d",
        "storage_key": "property/6767906449165620/019cfb45-b14f-7459-845d-ff1f5c8a6d7d.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Heritage Park Local Apartment Community Temple",
      "seo_description": "Live near Heritage Park in Temple at Portico at Friars Creek, a local apartment community offering modern amenities and nature access.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165620",
      "source": "generator",
      "page_item_url": "jaycee-park-close-apartment-homes-76502",
      "search_query": "Jaycee Park close apartment homes 76502",
      "category": "Park",
      "h1_title": "Jaycee Park Close Apartment Homes 76502",
      "h2_subtitle": "Discover apartment homes close to Jaycee Park in the 76502 area at Portico at Friars Creek. Ideal for nature lovers seeking comfort and convenience.",
      "page_copy": "Nestled in Temple's vibrant community, Portico at Friars Creek offers apartment homes close to Jaycee Park, located in the 76502 area. With inviting one and two-bedroom layouts, our apartments boast modern amenities such as a sundeck, pool, and fitness center, enhancing your living experience with both comfort and style.\n\nBeing near Jaycee Park means you can easily access outdoor activities, from leisurely walks to family picnics. Portico at Friars Creek combines the joy of nearby parklands with the convenience of urban living. Embrace the serene environment and the active lifestyle that living close to Jaycee Park affords, all while enjoying the supportive community atmosphere of Portico at Friars Creek.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019cfb45-b14f-7459-845d-ff1f5c8a6d7d.webp",
      "featured_image_media": {
        "alt_text": "Modern living and dining area with a white sofa, glass coffee table, dining table, and armchair.",
        "public_id": "019cfb45-b14f-7459-845d-ff1f5c8a6d7d",
        "storage_key": "property/6767906449165620/019cfb45-b14f-7459-845d-ff1f5c8a6d7d.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Jaycee Park Close Apartment Homes 76502",
      "seo_description": "Live near Jaycee Park in Temple's 76502 area at Portico at Friars Creek. Enjoy modern apartment homes with easy park access.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5200"
    },
    {
      "ID": "custom_ga4_id",
      "type": "STRING",
      "value": "G-H0F84D61RW"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "10041151117"
    },
    {
      "ID": "custom_tour24_url",
      "type": "STRING",
      "value": "https://app.tour24now.com/prospect/tour/portico-at-friars-creek/register/"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-P4T832V5"
    },
    {
      "ID": "custom_floorplan_pdf_url",
      "type": "STRING",
      "value": "https://multihubmedia.com/property/6767906449165620/019d1bd9-5aa4-752f-811c-e1d4f33da24b.pdf"
    },
    {
      "ID": "custom_rentgrata_property_id",
      "type": "STRING",
      "value": "bb95008b-ab5d-4492-85bb-d0c20403898c"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "833-772-5784"
    },
    {
      "ID": "custom_residentboost_apartment_id",
      "type": "STRING",
      "value": "653851f30488622720d83584"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IkNYV0ovamVkMFUyUFRGa05kcnd4NEE9PSIsInZhbHVlIjoiVlZFcWErMk95Qy9xcCs2V0FVUXNrZz09IiwibWFjIjoiZmI5NTYxNzY3NTQ0YjE0ZDQ5NzBhMjkzMDdmZGNmNTdkMWRlNWIzMWYzYzcwYWNhNWJjYTQyNDE5YzRiZTBlZCJ9"
    }
  ],
  "custom_qb_id": "5200",
  "custom_ga4_id": "G-H0F84D61RW",
  "custom_repli_id": "10041151117",
  "custom_tour24_url": "https://app.tour24now.com/prospect/tour/portico-at-friars-creek/register/",
  "custom_google_gtm_id": "GTM-P4T832V5",
  "custom_floorplan_pdf_url": "https://multihubmedia.com/property/6767906449165620/019d1bd9-5aa4-752f-811c-e1d4f33da24b.pdf",
  "custom_rentgrata_property_id": "bb95008b-ab5d-4492-85bb-d0c20403898c",
  "custom_ppc_tracking_phone_number": "833-772-5784",
  "custom_residentboost_apartment_id": "653851f30488622720d83584",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IkNYV0ovamVkMFUyUFRGa05kcnd4NEE9PSIsInZhbHVlIjoiVlZFcWErMk95Qy9xcCs2V0FVUXNrZz09IiwibWFjIjoiZmI5NTYxNzY3NTQ0YjE0ZDQ5NzBhMjkzMDdmZGNmNTdkMWRlNWIzMWYzYzcwYWNhNWJjYTQyNDE5YzRiZTBlZCJ9"
};

export const generatedAt = '2026-08-27T21:37:05.437Z';
